import React, {useEffect, useState} from "react";

export default function ParkaPrimoAussenjackeBack({
  lightContrast,
  darkContrast,
  stitching,
  patchColor,
  azomo,
  printStyle,
  getDataFromChild,
  preview,
}) {
  function adjust(color, amount) {
    return (
      "#" +
      color
        .replace(/^#/, "")
        .replace(/../g, (color) =>
          (
            "0" + Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)
          ).substr(-2)
        )
    );
  }

  const [darkenColor, setDarkenColor] = useState(darkContrast);

  const [lightContrastActive, setLightContrastActive] = useState(false);
  const [darkContrastActive, setDarkContrastActive] = useState(false);
  const [stitchingActive, setStitchingActive] = useState(false);
  const [patchActive, setPatchActive] = useState(false);
  const [azomoActive, setAzomoActive] = useState(false);

  const handleClick = (tabId) => {
    if (!preview) {
      getDataFromChild(tabId);
    }
  };

  useEffect(() => {
    setDarkenColor(adjust(lightContrast, -150));
  }, lightContrast);

  return (
    <svg
      className={printStyle}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 500 500"
      enableBackground="new 0 0 500 500"
    >
      <g>
        <path
          fill={lightContrast}
          onClick={() => handleClick("base")}
          onMouseEnter={() => setLightContrastActive(true)}
          onMouseLeave={() => setLightContrastActive(false)}
          style={
            lightContrastActive && !preview
              ? {fill: adjust(lightContrast, 55)}
              : {fill: lightContrast}
          }
          d="M248.961,388.709c-10.494,0-20.933-0.635-31.024-1.886c-7.403-0.926-14.818-2.202-22.035-3.79
		c-1.237-0.267-2.504-0.531-3.79-0.79c-6.011-1.228-12.212-2.492-17.352-5.431c-5.078-2.898-10.615-7.256-15.593-12.269
		c-3.414-3.439-5.343-8.421-5.29-13.67c0.09-8.829-0.282-27.719-1.141-57.749l-0.01-0.323c-0.347-12.139-0.714-24.056-1.015-33.741
		l-0.065-2.134c-0.328-10.682-0.565-18.4-0.552-19.597c0.016-2.025,0.817-12.125,1.988-23.938l0.264-2.662l-1.881,1.669
		c-10.199,9.051-24.481,35.922-29.833,50.444c-1.977,5.384-4.197,13.624-6.549,22.347c-4.436,16.449-9.463,35.092-13.674,37.372
		c-2.269,1.232-5.769,1.91-9.856,1.91c-7.639,0-15.538-2.24-21.129-5.992c-8.721-5.861-9.042-13.607-9.05-14.481l0.012-0.085v0.001
		c0.005,0,0.102-0.4,0.258-1.031l0.108-0.436l-0.004-0.008c1.677-6.909,5.411-22.358,6.068-25.564
		c0.23-1.132,0.54-2.855,0.947-5.269l0.028-0.152c0.633-3.769,1.244-7.77,1.327-8.323l0.008-0.029
		c0.337-1.042,3.429-10.897,4.375-22.045c1.001-11.74,19.673-60.43,19.861-60.92l0.086-0.167
		c3.851-7.886,23.358-47.869,29.265-60.586c6.25-13.45,24.266-35.793,25.029-36.738l0.164-0.203
		c1.936-1.282,16.582-10.844,27.413-13.974c6.265-1.804,14.812-4.042,21.051-5.675c5.564-1.455,9.589-2.514,10.702-2.887
		l0.513-0.171l0.156-0.571c4.043-14.817,11.391-27.117,21.84-36.563c1.758-0.81,6.482-2.448,16.34-2.448
		c1.283,0,2.628,0.028,3.998,0.084c1.441-0.056,2.787-0.084,4.069-0.084c10.021,0,14.735,1.692,16.34,2.448
		c10.449,9.444,17.797,21.746,21.842,36.564l0.156,0.571l0.514,0.172c1.13,0.377,5.418,1.502,10.382,2.803l0.317,0.083
		c6.255,1.638,14.819,3.881,21.051,5.676c10.887,3.145,25.549,12.736,27.415,13.975l0.163,0.201
		c0.764,0.945,18.777,23.285,25.03,36.738c5.608,12.081,23.689,49.169,29.098,60.249l0.263,0.538
		c0.177,0.457,18.849,49.147,19.85,60.888c0.94,11.076,3.977,20.808,4.368,22.018c0,0,0.053,0.324,0.11,0.696
		c0.214,1.38,0.715,4.607,1.232,7.684l0.12,0.701c0.323,1.92,0.623,3.579,0.854,4.716c0.69,3.355,4.812,20.382,6.123,25.785
		c0,0,0.298,1.227,0.321,1.323c-0.004,0.793-0.274,8.599-9.05,14.497c-5.592,3.752-13.491,5.992-21.129,5.992
		c-4.088,0-7.589-0.678-9.855-1.909c-4.214-2.282-9.24-20.925-13.675-37.373c-2.352-8.723-4.572-16.963-6.549-22.346
		c-5.352-14.523-19.633-41.393-29.833-50.445l-1.881-1.669l0.264,2.662c1.169,11.79,1.972,21.894,1.988,23.933
		c0.014,1.218-0.229,9.113-0.566,20.041l-0.216,7.039c-0.26,8.491-0.555,18.13-0.837,27.899l-0.021,0.761
		c-0.203,7.14-0.4,14.335-0.576,21.184l-0.021,0.856h0.002c-0.518,20.826-0.676,33.516-0.485,38.785
		c0.093,2.623-0.64,5.146-2.064,7.106c-1.763,2.428-4.218,4.558-6.19,6.268l-0.313,0.274c-4.298,3.732-9.174,7.966-14.607,10.371
		c-5.726,2.538-12.162,3.717-18.386,4.859l-0.332,0.061c-1.135,0.209-2.256,0.415-3.367,0.631
		c-7.644,1.479-15.438,2.662-23.163,3.516C269.417,388.125,259.084,388.709,248.961,388.709z"
        />
        <path
          fill="#C8C8C8"
          d="M336.916,83.289c-2.56-2.277-5.286-4.495-8.21-6.424c-2.582-1.703-5.454-3.285-8.841-4.868
		c0.251-1.095,0.155-3.342,0.056-4.818c1.979,0.546,3.881,1.075,5.611,1.572c3.535,1.023,7.477,2.73,11.246,4.612
		C336.907,76.455,337.025,81.075,336.916,83.289"
        />
        <path
          fill="#223A73"
          d="M209.555,57.299l-0.189,0.607c0.062-0.205,0.124-0.402,0.184-0.607H209.555z"
        />
        <path
          fill="#223A73"
          d="M210.146,55.349l-0.127,0.423h-0.01C210.058,55.631,210.099,55.49,210.146,55.349"
        />
        <path
          fill="#C8C8C8"
          d="M183.058,71.631c-6.385,2.922-12.199,6.897-17.415,11.234c-0.112-2.147,0-6.696,0.13-9.821
		c3.575-1.75,7.274-3.328,10.611-4.293c2.045-0.588,4.327-1.225,6.71-1.871C182.994,68.192,182.881,70.363,183.058,71.631"
        />
        <path
          fill="#C8C8C8"
          d="M79.155,265.038l-3.643,15.382c-4.726-4.119-6.134-7.92-6.468-9.059c0.624-3.733,1.222-7.611,1.304-8.141
		c0.139-0.43,0.975-3.072,1.898-6.989c0.797,1.911,2.599,5.098,6.524,8.485C78.895,264.822,79.026,264.932,79.155,265.038"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M107.354,310.837c-2.11,6.043-4.19,10.529-6.044,11.532c-6.189,3.353-21.292,2.282-30.767-4.075
		c-7.624-5.117-8.741-11.851-8.911-13.78c2.396,4.225,4.688,4.683,4.795,4.702l0.464,0.082l0.195-0.473
		c3.553-8.711,2.686-9.411,2.317-9.705c-0.463-0.394-2.755-4.176-4.752-7.688c0.16-0.675,0.325-1.35,0.486-2.025
		c0.748,2.011,2.339,5.04,5.704,8.239C75.988,302.531,86.494,308.753,107.354,310.837"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M68.567,300.115c0.069,0.863-1.118,4.432-2.373,7.578c-0.776-0.397-2.487-1.626-4.202-5.229
		c0.476-1.967,1.317-5.445,2.231-9.237C65.534,295.507,67.744,299.255,68.567,300.115"
        />
        <path
          fill="#C8C8C8"
          d="M349.762,225.847l-0.164-0.086c-0.039,0.086-3.869,8.943-9.506,11.707
		c-0.497,0.241-0.986,0.496-1.481,0.747c-0.653,0.343-1.333,0.69-2.006,1.008c-1.728,0.806-3.595,1.518-5.709,2.175
		c-2.839,0.883-5.979,1.65-9.883,2.407c-4.64,0.897-9.713,1.664-15.96,2.402c-7.105,0.839-14.703,1.534-23.921,2.17l-1.435,0.102
		c-9.859,0.685-20.053,1.395-30.074,1.395h-0.329c-8.205-0.015-16.602-0.627-24.72-1.225c-1.56-0.111-3.112-0.227-4.666-0.338
		c-8.283-0.584-15.197-1.212-21.752-1.964c-5.843-0.671-10.652-1.355-15.137-2.161c-3.868-0.699-7.018-1.395-9.912-2.199
		c-2.309-0.636-4.306-1.312-6.095-2.055c-1.105-0.454-2.252-0.998-3.725-1.761l-0.277-0.144c-0.369-0.189-0.733-0.382-1.105-0.559
		c-5.654-2.774-9.562-10.699-9.601-10.776l-0.238,0.14c0.363-4.254,0.831-9.363,1.36-14.629c0.031-0.019,0.065-0.049,0.096-0.073
		l-0.075-0.126c0.196-1.963,0.403-3.95,0.611-5.918c1.022,2.315,3.223,6.044,7.338,8.061c0.374,0.183,0.746,0.376,1.114,0.569
		l0.438,0.226c1.465,0.757,2.773,1.361,3.995,1.853c1.927,0.776,4.076,1.48,6.575,2.146c3.09,0.824,6.456,1.544,10.592,2.252
		c4.762,0.821,9.865,1.515,16.069,2.19c6.845,0.743,14.37,1.385,23.009,1.954c1.265,0.088,2.53,0.174,3.795,0.256
		c7.867,0.535,15.972,1.085,23.987,1.085c0.987,0,1.975-0.009,2.958-0.024c10.025-0.183,20.215-0.941,30.07-1.68l0.659-0.048
		c8.621-0.641,15.752-1.326,22.431-2.161c5.88-0.729,10.666-1.481,15.059-2.363c3.722-0.748,6.723-1.5,9.457-2.373
		c2.05-0.651,3.882-1.361,5.593-2.166c0.664-0.314,1.321-0.65,1.954-0.983c0.481-0.247,0.962-0.497,1.447-0.733
		c4.012-1.969,6.169-5.952,7.205-8.567c0.226,2.131,0.45,4.293,0.663,6.424l-0.073,0.126c0.03,0.024,0.065,0.053,0.095,0.077
		C348.974,217.068,349.414,221.8,349.762,225.847"
        />
        <path
          fill="#C8C8C8"
          d="M348.886,295.358c-0.178,6.338-0.351,12.686-0.502,18.763c-0.573,1.433-3.31,7.723-8.292,10.168
		c-0.498,0.241-0.987,0.497-1.481,0.747c-0.654,0.343-1.334,0.691-2.006,1.009c-1.729,0.805-3.596,1.518-5.71,2.175
		c-2.838,0.882-5.978,1.649-9.883,2.406c-4.64,0.897-9.712,1.664-15.959,2.403c-7.105,0.839-14.704,1.533-23.922,2.171l-1.434,0.101
		c-9.86,0.684-20.054,1.393-30.074,1.393h-0.33c-8.206-0.015-16.601-0.627-24.719-1.225c-1.561-0.111-3.112-0.226-4.667-0.338
		c-8.283-0.584-15.196-1.21-21.751-1.963c-5.844-0.671-10.653-1.356-15.137-2.162c-3.869-0.699-7.018-1.393-9.912-2.198
		c-2.309-0.638-4.306-1.313-6.095-2.056c-1.105-0.452-2.252-0.998-3.726-1.761l-0.277-0.144c-0.368-0.189-0.733-0.381-1.105-0.559
		c-5.341-2.62-8.101-9.657-8.379-10.394c-0.151-5.923-0.316-12.083-0.49-18.232c1.586,2.724,4.455,6.766,8.362,8.681
		c0.373,0.183,0.745,0.376,1.114,0.568l0.437,0.227c1.465,0.757,2.773,1.361,3.996,1.852c1.926,0.777,4.076,1.482,6.575,2.147
		c3.089,0.825,6.455,1.543,10.592,2.253c4.761,0.819,9.864,1.514,16.068,2.19c6.845,0.743,14.37,1.384,23.009,1.954
		c1.265,0.086,2.531,0.173,3.795,0.256c7.867,0.534,15.972,1.085,23.987,1.085c0.988,0,1.976-0.01,2.958-0.025
		c10.026-0.183,20.215-0.941,30.071-1.678l0.658-0.049c8.621-0.642,15.753-1.326,22.432-2.162c5.879-0.727,10.666-1.48,15.059-2.363
		c3.721-0.748,6.723-1.5,9.456-2.373c2.05-0.651,3.882-1.361,5.594-2.165c0.663-0.314,1.321-0.651,1.954-0.984
		c0.481-0.245,0.961-0.497,1.447-0.733C344.489,302.435,347.318,298.233,348.886,295.358"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M347.872,353.934c0.091,2.556-0.624,5.016-2.014,6.937c-1.751,2.406-4.194,4.529-6.157,6.232l-0.307,0.265
		c-4.294,3.724-9.154,7.948-14.552,10.336c-5.704,2.528-12.13,3.71-18.341,4.849c-1.248,0.226-2.484,0.452-3.701,0.689
		c-7.638,1.476-15.427,2.657-23.146,3.517c-21.136,2.363-41.892,2.311-61.695-0.155c-7.352-0.916-14.76-2.19-22.011-3.781
		c-1.235-0.269-2.504-0.531-3.795-0.796c-5.982-1.22-12.173-2.485-17.286-5.407c-5.077-2.895-10.596-7.24-15.548-12.229
		c-3.366-3.395-5.263-8.305-5.211-13.481c0.069-6.897-0.156-19.434-0.502-33.735c1.394,2.663,3.951,6.507,7.793,8.393
		c0.364,0.178,0.724,0.367,1.079,0.55l0.282,0.144c1.504,0.782,2.682,1.337,3.816,1.804c1.838,0.763,3.873,1.448,6.23,2.104
		c2.929,0.81,6.113,1.515,10.015,2.219c4.506,0.81,9.342,1.5,15.206,2.175c6.572,0.752,13.5,1.38,21.804,1.967
		c1.552,0.111,3.102,0.223,4.662,0.338c8.139,0.599,16.557,1.212,24.802,1.225h0.329c10.058,0,20.274-0.709,30.151-1.398
		l1.434-0.097c9.237-0.641,16.857-1.337,23.974-2.18c6.277-0.743,11.376-1.511,16.041-2.412c3.952-0.767,7.132-1.539,10.008-2.437
		c2.165-0.674,4.08-1.408,5.857-2.237c0.698-0.323,1.387-0.681,2.054-1.023c0.481-0.25,0.967-0.501,1.456-0.743
		c3.764-1.847,6.294-5.57,7.703-8.228C347.898,334.019,347.665,348.227,347.872,353.934"
        />
        <path
          fill="#C8C8C8"
          d="M432.87,271.361c-0.333,1.139-1.742,4.94-6.468,9.059l-3.642-15.382c0.13-0.106,0.259-0.217,0.385-0.324
		c3.925-3.386,5.723-6.574,6.524-8.485c0.923,3.918,1.759,6.56,1.898,6.99C431.649,263.75,432.242,267.628,432.87,271.361"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M439.923,302.463c-1.672,3.53-3.249,4.785-4.02,5.209c-1.659-4.558-2.344-7.196-2.288-7.756
		c0.239-0.525,2.145-3.56,4.099-6.604C438.62,297.07,439.451,300.514,439.923,302.463"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M440.278,304.522c-0.168,1.954-1.304,8.669-8.907,13.771c-9.474,6.358-24.577,7.428-30.767,4.076
		c-1.855-1.004-3.934-5.489-6.043-11.532c20.859-2.083,31.364-8.306,36.511-13.193c3.367-3.198,4.956-6.227,5.705-8.244
		c0.174,0.733,0.351,1.471,0.529,2.205c-1.186,1.832-4.544,7.057-4.831,7.794c-0.13,0.339-0.476,1.231,2.37,9.011
		c0.103,0.284,0.303,0.501,0.554,0.623c0.126,0.058,0.255,0.086,0.39,0.086c0.134,0,0.263-0.028,0.389-0.086
		C437.042,308.632,438.606,307.523,440.278,304.522"
        />
        <path
          fill="#C8C8C8"
          d="M403.273,171.946c-2.201,2.748-5.821,7.217-9.403,11.514c-0.022,0.042-0.056,0.078-0.084,0.115
		c-0.043,0.084-0.09,0.157-0.155,0.225c-0.211,0.261-0.451,0.491-0.685,0.721c0.005,0.011,0.009,0.022,0.018,0.026
		c-1.817,2.164-3.647,4.318-5.521,6.418c-1.789,2.003-3.652,3.946-5.769,5.514c-2.206,1.641-4.484,3.189-6.811,4.6
		c-1.009,0.611-2.027,1.197-3.066,1.74c-4.168,2.18-8.58,3.888-13.143,4.646c-3.122,0.513-6.323,0.565-9.43-0.073
		c-0.507-4.813-1.042-9.58-1.577-13.778c0.005,0.032,3.205-0.982,3.488-1.091c1.224-0.455,2.427-0.977,3.614-1.542
		c2.511-1.202,4.943-2.597,7.328-4.077c2.45-1.521,4.878-3.094,7.267-4.729c2.261-1.547,4.566-3.084,6.665-4.908
		c1.525-1.317,2.976-2.744,4.384-4.212c0.765-0.794,1.515-1.599,2.262-2.42c0.211-0.235,2.244-2.269,2.164-2.446
		c0.005,0.005,0.009,0.01,0.009,0.016c0.076-0.094,0.164-0.178,0.267-0.236c0.014-0.01,0.037-0.025,0.056-0.036
		c0.192-0.256,0.395-0.507,0.582-0.768c-0.005-0.01-0.008-0.02-0.013-0.025c4.328-5.07,8.032-9.993,9.436-11.881
		C398.207,161.545,401.081,167.451,403.273,171.946"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M394.528,153.957c0.084,0.183-1.709,2.273-1.854,2.466c-1.142,1.496-2.301,2.98-3.47,4.443
		c-4.981,6.235-10.21,12.894-16.57,17.425c-4.643,3.313-9.431,6.527-14.355,9.324c-1.783,1.009-3.605,1.955-5.469,2.77
		c-0.422,0.189-5.323,1.981-5.337,1.872c-0.629-4.845-1.248-8.802-1.779-10.97c-0.239-0.962-0.253-2.002-0.282-2.995
		c-0.051-1.678-0.014-3.361,0.038-5.039c0.065-2.243,0.184-4.484,0.31-6.722c0.159-2.686,0.342-5.373,0.544-8.053
		c0.22-3.011,0.464-6.022,0.723-9.031c0.164-1.965,0.352-3.925,0.475-5.89c0.046-0.711,0.164-1.416,0.225-2.128
		c0.07-0.742,0.136-1.49,0.206-2.232c0.137-1.499,0.278-2.999,0.424-4.494c0.286-3.005,0.577-6.01,0.877-9.016
		c0.291-2.948,0.592-5.891,0.892-8.834c0.291-2.79,0.582-5.581,0.878-8.372c0.244-2.341,0.375-4.719,0.746-7.034
		c0.094-0.565,0.112-1.14,0.15-1.709c0.038-0.574,0.159-1.118,0.221-1.688c0.028-0.293,0.062-0.591,0.094-0.883
		c0.065-0.575,0.128-1.145,0.188-1.72c0.117-1.056,0.235-2.116,0.352-3.178c0.193-1.74,0.385-3.48,0.582-5.222
		c0.07-0.622,0.141-1.249,0.211-1.877c0.029-0.261,0.061-0.523,0.089-0.783c0.009-0.09,0.127-0.591,0.076-0.654
		c3.803,4.777,18.702,23.79,24.284,35.801C381.13,126.283,388.138,140.802,394.528,153.957"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M156.417,179.916c-0.022,0.261-0.047,0.518-0.084,0.78c-0.029,0.182-0.112,0.407-0.112,0.59
		c-0.532,2.169-1.15,6.125-1.78,10.97c-7.538-1.897-15.711-7.5-23.615-12.931c0,0-0.884-0.606-0.884-0.616
		c-0.375-0.199-0.75-0.424-1.061-0.737c-3.366-2.446-7.467-6.768-11.2-11.117c-0.333-0.288-0.601-0.643-0.887-0.998
		c-0.014-0.022-0.023-0.042-0.038-0.063c-4.544-5.364-8.375-10.49-9.369-11.839c6.388-13.155,13.397-27.674,16.532-34.422
		c5.582-12.009,20.481-31.023,24.283-35.801c-0.052,0.063,0.066,0.59,0.08,0.684c0.029,0.277,0.061,0.555,0.094,0.826
		c0.076,0.668,0.151,1.338,0.226,2.007c0.197,1.766,0.394,3.533,0.592,5.294c0.107,0.992,0.215,1.986,0.328,2.979
		c0.057,0.527,0.112,1.056,0.169,1.583c0.033,0.272,0.061,0.544,0.089,0.815c0.076,0.655,0.193,1.313,0.258,1.977
		c0.216,2.158,0.442,4.312,0.653,6.47c0.05,0.502,0.107,1.009,0.159,1.512c0.296,2.78,0.586,5.56,0.873,8.34
		c0.3,2.932,0.6,5.869,0.891,8.806c0.301,3.006,0.596,6.011,0.883,9.022c0.15,1.588,0.314,3.182,0.47,4.776
		c0.155,1.569,0.262,3.146,0.394,4.719c0.127,1.558,0.31,3.11,0.446,4.667c0.155,1.783,0.282,3.571,0.423,5.358
		c0.234,2.88,0.45,5.759,0.648,8.645c0.174,2.503,0.324,5.007,0.445,7.511c0.099,2.006,0.174,4.009,0.198,6.015
		C156.534,177.131,156.534,178.532,156.417,179.916"
        />
        <path
          fill="#C8C8C8"
          d="M154.267,193.615c-0.535,4.197-1.071,8.963-1.577,13.778c-4.675,0.956-9.502,0.365-14.055-1.025
		c-4.172-1.27-8.177-3.198-11.969-5.503c-2.704-1.641-5.244-3.518-7.769-5.473c-0.794-0.616-1.555-1.342-2.258-2.074
		c-0.747-0.773-1.47-1.573-2.188-2.378c-1.915-2.143-3.736-4.385-5.615-6.57c-0.605-0.7-1.197-1.416-1.794-2.112
		c-0.47-0.543-0.92-1.114-1.379-1.667c-0.883-1.071-1.766-2.148-2.643-3.225c-1.465-1.798-2.929-3.606-4.379-5.419
		c2.192-4.495,5.064-10.401,8.116-16.689c-0.056,0.125,1.187,1.583,1.3,1.73c0.644,0.851,1.286,1.694,1.94,2.529
		c1.714,2.202,3.459,4.376,5.247,6.503c3.615,4.301,7.329,8.665,11.67,12.073c0.616,0.486,1.244,0.946,1.888,1.385
		c4.67,3.177,9.247,6.491,14.129,9.271C146.532,190.803,150.301,192.633,154.267,193.615"
        />
        <path
          fill="#C8C8C8"
          d="M425.341,281.303c-5.649,4.49-16.376,9.921-36.126,11.822c-0.745-2.702-1.473-5.393-2.171-7.978
		c-0.688-2.552-1.365-5.065-2.026-7.471l0.056-0.035c19.681-1.842,30.663-7.176,36.62-11.75L425.341,281.303z"
        />
        <path
          fill="#C8C8C8"
          d="M116.897,277.676c-0.663,2.406-1.339,4.919-2.027,7.471c-0.697,2.586-1.425,5.277-2.17,7.979
		c-19.751-1.9-30.477-7.332-36.126-11.823l3.647-15.411c5.957,4.573,16.94,9.908,36.62,11.75L116.897,277.676z"
        />
        <path
          fill="#010101"
          d="M85.034,317.482c-1.084,0-1.965-0.982-1.965-2.188c0-1.207,0.881-2.188,1.965-2.188
		s1.965,0.981,1.965,2.188C86.999,316.5,86.118,317.482,85.034,317.482 M85.034,313.623c-0.828,0-1.501,0.749-1.501,1.671
		c0,0.921,0.673,1.671,1.501,1.671c0.828,0,1.501-0.75,1.501-1.671C86.535,314.372,85.862,313.623,85.034,313.623"
        />
        <path
          fill="#010101"
          d="M85.034,316.387c-0.542,0-0.982-0.49-0.982-1.095c0-0.602,0.44-1.093,0.982-1.093
		c0.542,0,0.982,0.491,0.982,1.093C86.016,315.898,85.576,316.387,85.034,316.387 M85.034,314.457c-0.413,0-0.75,0.375-0.75,0.835
		c0,0.461,0.337,0.837,0.75,0.837c0.413,0,0.75-0.375,0.75-0.837C85.784,314.833,85.448,314.457,85.034,314.457"
        />
        <path
          fill="#010101"
          d="M74.204,312.659c-1.084,0-1.965-0.983-1.965-2.188c0-1.207,0.881-2.189,1.965-2.189
		c1.084,0,1.965,0.982,1.965,2.189C76.169,311.676,75.288,312.659,74.204,312.659 M74.204,308.799c-0.828,0-1.501,0.75-1.501,1.672
		c0,0.921,0.673,1.67,1.501,1.67c0.828,0,1.501-0.749,1.501-1.67C75.704,309.549,75.032,308.799,74.204,308.799"
        />
        <path
          fill="#010101"
          d="M74.204,311.564c-0.542,0-0.982-0.49-0.982-1.093s0.44-1.095,0.982-1.095c0.542,0,0.982,0.491,0.982,1.095
		S74.746,311.564,74.204,311.564 M74.204,309.635c-0.413,0-0.75,0.375-0.75,0.835c0,0.461,0.337,0.835,0.75,0.835
		c0.413,0,0.75-0.374,0.75-0.835C74.954,310.01,74.617,309.635,74.204,309.635"
        />
        <path
          fill="#010101"
          d="M65.13,303.984c-0.328,0-0.638-0.134-0.904-0.391c-0.396-0.382-0.646-0.999-0.685-1.692
		c-0.075-1.296,0.573-2.511,1.474-2.769c0.418-0.117,0.838-0.022,1.184,0.274c0.465,0.4,0.748,1.123,0.755,1.933
		c0.01,1.374-0.761,2.558-1.719,2.64C65.201,303.983,65.166,303.984,65.13,303.984 M65.364,299.564
		c-0.079,0-0.159,0.013-0.241,0.035c-0.695,0.199-1.211,1.217-1.15,2.269c0.033,0.567,0.228,1.063,0.537,1.362
		c0.205,0.198,0.442,0.291,0.692,0.269c0.725-0.063,1.328-1.049,1.319-2.155c-0.005-0.665-0.225-1.245-0.585-1.555
		C65.762,299.64,65.567,299.564,65.364,299.564"
        />
        <path
          fill="#010101"
          d="M425.977,312.659c-1.083,0-1.965-0.983-1.965-2.188c0-1.207,0.882-2.189,1.965-2.189
		c1.084,0,1.966,0.982,1.966,2.189C427.944,311.676,427.062,312.659,425.977,312.659 M425.977,308.799
		c-0.828,0-1.501,0.75-1.501,1.672c0,0.921,0.673,1.67,1.501,1.67c0.828,0,1.502-0.749,1.502-1.67
		C427.479,309.549,426.805,308.799,425.977,308.799"
        />
        <path
          fill="#010101"
          d="M425.977,311.564c-0.541,0-0.982-0.49-0.982-1.093s0.441-1.095,0.982-1.095
		c0.542,0,0.983,0.491,0.983,1.095S426.519,311.564,425.977,311.564 M425.977,309.635c-0.413,0-0.749,0.375-0.749,0.835
		c0,0.461,0.336,0.835,0.749,0.835s0.75-0.374,0.75-0.835C426.728,310.01,426.391,309.635,425.977,309.635"
        />
        <path
          fill="#010101"
          d="M415.147,317.482c-1.083,0-1.965-0.982-1.965-2.188c0-1.207,0.882-2.188,1.965-2.188
		c1.084,0,1.966,0.981,1.966,2.188C417.113,316.5,416.231,317.482,415.147,317.482 M415.147,313.623
		c-0.828,0-1.501,0.749-1.501,1.671c0,0.921,0.673,1.671,1.501,1.671s1.502-0.75,1.502-1.671
		C416.649,314.372,415.975,313.623,415.147,313.623"
        />
        <path
          fill="#010101"
          d="M415.147,316.387c-0.541,0-0.982-0.49-0.982-1.095c0-0.602,0.441-1.093,0.982-1.093
		c0.542,0,0.983,0.491,0.983,1.093C416.13,315.898,415.689,316.387,415.147,316.387 M415.147,314.457
		c-0.413,0-0.749,0.375-0.749,0.835c0,0.461,0.336,0.837,0.749,0.837s0.75-0.375,0.75-0.837
		C415.897,314.833,415.56,314.457,415.147,314.457"
        />
        <path
          fill="#010101"
          d="M437.057,303.306c-0.108,0-0.216-0.016-0.326-0.045c-0.861-0.241-1.484-1.395-1.419-2.628
		c0.035-0.661,0.27-1.251,0.646-1.617c0.28-0.274,0.611-0.404,0.964-0.376c0.914,0.075,1.655,1.198,1.65,2.505
		c-0.002,0.773-0.268,1.463-0.711,1.846C437.622,303.198,437.344,303.306,437.057,303.306 M436.831,299.119
		c-0.21,0-0.411,0.089-0.586,0.259c-0.29,0.283-0.472,0.75-0.499,1.282c-0.053,0.992,0.437,1.949,1.091,2.131
		c0.271,0.076,0.534,0.014,0.76-0.182c0.338-0.293,0.541-0.841,0.543-1.466c0.003-1.042-0.568-1.967-1.248-2.022
		C436.871,299.119,436.851,299.119,436.831,299.119"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
		M401.657,171.737c-1.61,2.003-5.086,6.306-8.762,10.716l-0.086,0.102l-0.032,0.053l-0.087,0.111l-0.037,0.074l-0.013,0.016
		c-0.144,0.177-0.328,0.358-0.524,0.55l-0.813,0.796l0.057,0.13c-1.456,1.729-3.123,3.684-4.862,5.636
		c-1.652,1.849-3.47,3.775-5.561,5.324c-2.239,1.665-4.495,3.189-6.71,4.532c-1.081,0.656-2.061,1.212-2.996,1.701
		c-4.526,2.366-8.705,3.846-12.773,4.521c-1.53,0.251-3.038,0.378-4.481,0.378c-1.216,0-2.406-0.091-3.55-0.269"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
		M349.13,194.714c1.112-0.341,2.427-0.785,2.446-0.793c1.154-0.428,2.369-0.947,3.696-1.578c2.304-1.104,4.671-2.42,7.452-4.145
		c2.556-1.586,5.017-3.188,7.316-4.761l0.58-0.397c2.079-1.418,4.229-2.886,6.208-4.605c1.396-1.206,2.821-2.573,4.475-4.299
		c0.717-0.746,1.436-1.514,2.195-2.346v0.31l1.542-1.93c0.335-0.367,0.593-0.675,0.778-0.952l0.178-0.099l0.178-0.236l0.21-0.275
		c0.132-0.17,0.263-0.342,0.39-0.517l0.162-0.227c3.176-3.735,6.056-7.436,7.982-9.978"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
		M151.486,206.109c-1.148,0.18-2.338,0.271-3.55,0.271c-2.808,0-5.819-0.484-8.948-1.44c-3.774-1.149-7.706-2.957-11.684-5.375
		c-2.801-1.699-5.437-3.678-7.647-5.389c-0.645-0.501-1.335-1.137-2.11-1.941c-0.745-0.772-1.473-1.581-2.151-2.339
		c-1.191-1.333-2.371-2.735-3.513-4.091c-0.692-0.823-1.383-1.646-2.085-2.46c-0.334-0.386-0.661-0.775-0.988-1.163
		c-0.267-0.317-0.536-0.634-0.803-0.947c-0.298-0.346-0.585-0.698-0.872-1.05c-0.164-0.2-0.329-0.401-0.493-0.6
		c-0.879-1.065-1.759-2.14-2.636-3.215c-1.252-1.537-2.505-3.081-3.75-4.632"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
		M106.994,157.888l0.059,0.072c0.634,0.84,1.281,1.688,1.939,2.53c1.852,2.377,3.579,4.518,5.282,6.542
		c3.415,4.064,7.286,8.67,11.874,12.272c0.619,0.489,1.279,0.973,1.958,1.437c0.991,0.675,1.977,1.355,2.962,2.035
		c3.62,2.496,7.363,5.076,11.256,7.294c2.556,1.458,6.325,3.465,10.458,4.67"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M386.76,278.961
		c0.317-0.033,0.631-0.068,0.942-0.103"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="0.011,0"
          x1="389.671"
          y1="278.62"
          x2="389.682"
          y2="278.618"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.95,1.94,0.011,0"
          d="
		M389.682,278.618c15.193-1.963,24.668-6.098,30.39-9.827"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M420.071,268.792
		c0.277-0.181,0.545-0.36,0.805-0.54l0.24,1.016"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="0.01,0"
          x1="421.606"
          y1="271.336"
          x2="421.608"
          y2="271.347"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.891,1.881,0.01,0"
          x1="421.608"
          y1="271.347"
          x2="423.576"
          y2="279.66"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M423.576,279.66l0.24,1.016
		c-0.252,0.189-0.514,0.378-0.787,0.571"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="0.01,0"
          x1="421.346"
          y1="282.361"
          x2="421.337"
          y2="282.367"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.929,1.918,0.01,0"
          d="
		M421.338,282.366c-5.719,3.568-15.117,7.38-30.219,9.072"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M391.113,291.439
		c-0.312,0.035-0.626,0.069-0.942,0.102"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
		M292.546,54.826c-0.483-0.094-2.698-0.766-3.157-0.852c-2.6-0.488-5.237-0.935-7.787-1.368l-0.104-0.017
		c-4.222-0.719-8.547-0.871-12.732-1.016c-0.961-0.035-1.916-0.068-2.868-0.107c-7.72-0.325-15.622-0.488-24.159-0.498h-0.131
		c-4.879,0-10.084,0.341-16.38,1.074c-1.228,0.142-2.403,0.29-3.488,0.438c-3.467,0.472-6.908,1.04-10.227,1.689
		c-0.134,0.026-2.009,0.632-2.145,0.658"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
		M335.868,72.673c0.094,2.374,0.233,6.556,0.225,8.668c-2.474-2.125-4.71-3.833-6.944-5.306c-2.452-1.617-5.179-3.135-8.318-4.629
		c0.07-0.751,0.36-3.292,0.307-4.521"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
		M182.075,66.402c-0.045,0.924,0.001,3.719,0.055,4.615c-5.192,2.444-10.453,5.796-15.666,9.98
		c-0.012-2.057,0.353-6.846,0.447-9.289"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
		M349.413,99.316c-3.717,34.223-7.764,76.024-6.155,82.572c0,0,0.841,1.727,2.141,2.208"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
		M156.524,183.693c0.875,0.081,2.133-1.806,2.133-1.806c1.609-6.548-2.44-48.35-6.156-82.573"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M317.93,70.085
		c-0.295-0.128-0.587-0.255-0.879-0.378"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="0.01,0"
          x1="315.288"
          y1="68.966"
          x2="315.279"
          y2="68.963"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.855,1.845,0.01,0"
          d="
		M315.28,68.963c-0.509-0.21-1.023-0.417-1.537-0.623c-1.628-0.647-3.252-1.289-4.879-1.927l-0.172-0.067
		c-2.535-0.997-5.107-2.01-7.682-3.062"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          d="M301.01,63.284
		c-0.295-0.12-0.59-0.241-0.884-0.364"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
		M351.897,81.355c-0.231,2.024-0.937,7.996-1.578,13.806c-2.912-3.137-5.984-6.233-9.152-9.221c-0.72-0.677-1.452-1.361-2.2-2.045
		c0.148-1.941,0.022-6.995-0.066-9.776"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
		M163.447,73.638c-0.08,2.514-0.007,7.775,0.14,9.758c-3.878,3.351-7.731,7.124-11.996,11.754
		c-0.637-5.803-1.342-11.764-1.574-13.794"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="M209.801,59.65
		c-2.3,0.95-12.657,5.15-14.917,6.052c-3.048,1.217-7.712,3.125-11.076,4.559"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
		M65.552,293.282c0.998,1.657,2.42,3.539,4.446,5.464c5.125,4.865,15.903,10.759,37.131,13.654"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
		M62.507,304.199c0.433,1.447,1.282,7.87,8.707,12.856c5.266,3.533,13.096,5.728,20.434,5.728c3.822,0,7.051-0.609,9.095-1.715
		l3.353-1.434"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
		M436.795,293.282c-0.997,1.657-2.42,3.539-4.445,5.464c-5.126,4.865-15.904,10.759-37.131,13.654"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
		M439.84,304.199c-0.433,1.447-1.282,7.87-8.707,12.856c-5.267,3.533-13.096,5.728-20.434,5.728c-3.822,0-7.051-0.609-9.095-1.715
		l-3.353-1.434"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
		M106.936,307.969c-18.568-1.952-28.374-7.212-33.433-11.547l3.393-11.494c5.856,4.086,16.192,8.868,33.718,10.807"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
		M68.138,275.259c1.03,1.48,3.569,5.373,5.492,7.091l-3.227,10.912c-2.399-2.955-4.232-7.489-4.431-8.357"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
		M71.605,258.377c1.098,1.712,3.766,5.186,6.073,7.223l-2.899,12.239c-2.897-2.942-5.392-7.737-5.774-8.851"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
		M394.997,307.969c18.568-1.952,28.374-7.212,33.434-11.547l-3.393-11.494c-5.855,4.086-16.193,8.868-33.719,10.807"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
		M433.795,275.259c-1.029,1.48-3.568,5.373-5.492,7.091l3.228,10.912c2.399-2.955,4.232-7.489,4.43-8.357"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
		M430.33,258.377c-1.099,1.712-3.767,5.186-6.073,7.223l2.898,12.239c2.897-2.942,5.393-7.737,5.774-8.851"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
		M152.617,297.688c1.684,2.141,5.676,7.02,8.258,8.285c0.361,0.177,0.725,0.365,1.082,0.554l0.444,0.23
		c1.469,0.759,2.81,1.381,4.101,1.9c1.993,0.802,4.189,1.521,6.716,2.194c3.154,0.842,6.554,1.565,10.696,2.275
		c4.764,0.822,9.894,1.52,16.139,2.2c6.924,0.751,14.467,1.391,23.059,1.957l0.303,0.02c1.164,0.08,2.329,0.159,3.492,0.235
		c7.861,0.535,15.992,1.088,24.063,1.088c0.993,0,1.987-0.01,2.976-0.025c10.172-0.186,20.78-0.98,30.14-1.681l0.656-0.048
		c8.686-0.646,15.833-1.335,22.492-2.166c5.889-0.731,10.702-1.486,15.145-2.379c3.772-0.757,6.818-1.522,9.585-2.405
		c2.103-0.669,3.981-1.397,5.74-2.223c0.766-0.364,1.509-0.751,2.002-1.009l0.278-0.142c0.377-0.194,0.755-0.389,1.136-0.574
		c2.559-1.257,6.518-5.6,8.178-7.804"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
		M348.864,311.676c-0.676,1.615-4.991,9.48-9.296,11.593c-0.375,0.18-0.748,0.372-1.123,0.564l-0.375,0.191
		c-0.784,0.411-1.408,0.724-1.976,0.993c-1.688,0.788-3.506,1.48-5.548,2.113c-2.812,0.874-5.912,1.629-9.756,2.377
		c-4.657,0.899-9.701,1.658-15.874,2.387c-7.194,0.85-14.777,1.539-23.866,2.165l-1.436,0.102
		c-9.86,0.685-20.023,1.391-29.991,1.391h-0.329c-8.249-0.015-16.954-0.656-24.635-1.222l-4.667-0.339
		c-8.202-0.577-15.098-1.2-21.702-1.958c-5.842-0.671-10.628-1.353-15.063-2.149c-3.877-0.702-6.993-1.392-9.803-2.175
		c-2.25-0.619-4.199-1.278-5.957-2.006c-1.05-0.431-2.168-0.96-3.633-1.717l-0.574-0.299c-0.28-0.144-0.559-0.288-0.844-0.423
		c-4.509-2.212-8.808-11.638-9.366-13.035"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
		M153.483,208.453c1.342,1.88,4.716,6.01,7.391,7.32c0.362,0.178,0.725,0.367,1.083,0.555l0.443,0.23
		c1.47,0.759,2.81,1.381,4.101,1.9c1.993,0.802,4.189,1.521,6.716,2.194c3.154,0.842,6.554,1.565,10.697,2.275
		c4.764,0.821,9.892,1.52,16.138,2.199c6.924,0.752,14.467,1.392,23.059,1.958l0.336,0.023c1.154,0.078,2.307,0.158,3.461,0.233
		c7.859,0.534,15.991,1.088,24.062,1.088c0.994,0,1.987-0.01,2.976-0.025c10.171-0.186,20.78-0.981,30.141-1.681l0.655-0.048
		c8.687-0.648,15.833-1.336,22.492-2.166c5.891-0.731,10.703-1.487,15.145-2.379c3.773-0.758,6.818-1.522,9.585-2.405
		c2.103-0.669,3.981-1.397,5.74-2.224c0.766-0.363,1.509-0.749,2.003-1.008l0.274-0.141c0.379-0.196,0.759-0.39,1.14-0.576
		c2.599-1.275,5.954-5.73,7.311-7.803"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
		M349.731,223.889c-0.412,0.921-5.295,10.169-10.162,12.558c-0.374,0.181-0.748,0.372-1.124,0.564l-0.374,0.191
		c-0.784,0.41-1.408,0.724-1.975,0.993c-1.689,0.787-3.507,1.479-5.549,2.112c-2.812,0.875-5.912,1.63-9.756,2.375
		c-4.656,0.9-9.701,1.659-15.873,2.389c-7.194,0.85-14.778,1.538-23.866,2.165l-1.437,0.101c-9.862,0.685-20.024,1.391-29.99,1.391
		h-0.33c-8.249-0.014-16.953-0.656-24.635-1.222l-4.667-0.339c-8.203-0.577-15.099-1.199-21.702-1.957
		c-5.841-0.671-10.628-1.354-15.062-2.15c-3.877-0.701-6.994-1.391-9.804-2.175c-2.25-0.621-4.198-1.275-5.957-2.006
		c-1.049-0.43-2.168-0.959-3.633-1.716l-0.574-0.299c-0.279-0.144-0.558-0.288-0.843-0.423
		c-5.119-2.513-10.069-12.222-10.234-12.553"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
		M153.605,345.44c0,0,12.009,15.677,25.004,21.465c12.997,5.789,45.527,9.94,59.351,11.094c17.329,1.447,60.218-2.412,74.081-6.271
		c13.863-3.859,31.192-18.303,35.957-25.081"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeDasharray="1.848,1.848"
          d="
		M112.049,292.09c-18.167-1.895-28.281-6.831-33.704-10.887l2.958-12.492c5.954,4.099,16.44,8.864,34.172,10.732"
        />
        <path
          d="M441.539,303.946l-0.022-0.168c-0.005-0.026-0.109-0.449-0.283-1.155c0.01-0.022,0.014-0.031,0.025-0.047l-0.039-0.022
		c-1.173-4.834-5.449-22.489-6.149-25.892c-0.262-1.297-0.605-3.225-0.938-5.226c0.014-0.073,0.023-0.125,0.028-0.136l-0.055-0.015
		c-0.677-4.02-1.324-8.295-1.338-8.357l-0.023-0.12c-0.038-0.099-3.357-10.275-4.338-21.82c-1-11.744-19.162-59.236-19.937-61.254
		l-0.028-0.058c-0.226-0.465-22.936-46.95-29.352-60.768c-6.117-13.16-23.189-34.515-25.175-36.971l0.019-0.131l-0.343-0.235
		c-0.16-0.105-16.097-10.777-27.747-14.143c-6.149-1.772-14.425-3.942-21.072-5.682c-4.882-1.28-9.515-2.493-10.641-2.869
		c-4.108-15.047-11.575-27.543-22.208-37.14l-0.066-0.063l-0.08-0.036c-1.933-0.925-7.825-3.006-20.818-2.478
		c-12.998-0.529-18.884,1.553-20.819,2.478l-0.08,0.036l-0.066,0.063c-10.632,9.596-18.099,22.092-22.206,37.14
		c-1.142,0.382-5.77,1.595-10.642,2.869c-6.648,1.74-14.923,3.91-21.073,5.682c-11.65,3.365-27.586,14.038-27.747,14.143
		l-0.341,0.235l0.018,0.131c-1.986,2.456-19.059,23.812-25.175,36.971c-6.417,13.819-29.127,60.303-29.353,60.768l-0.028,0.058
		c-0.775,2.017-18.937,49.509-19.937,61.254c-0.981,11.546-4.3,21.722-4.337,21.82l-0.029,0.12
		c-0.009,0.063-0.657,4.337-1.333,8.357l-0.056,0.015c0.005,0.011,0.014,0.064,0.029,0.136c-0.338,2.002-0.676,3.929-0.939,5.226
		c-0.698,3.403-4.976,21.058-6.148,25.892l-0.038,0.022c0.009,0.016,0.013,0.025,0.023,0.047c-0.175,0.706-0.277,1.129-0.282,1.155
		l-0.023,0.168c-0.005,0.365-0.048,9.083,9.534,15.521c6.248,4.193,14.637,6.152,21.645,6.152c4.159,0,7.839-0.69,10.294-2.023
		c4.605-2.493,9.482-20.577,14.195-38.053c2.352-8.728,4.577-16.965,6.515-22.244c5.428-14.728,19.538-41.127,29.532-49.996
		c-1.131,11.415-1.977,21.847-1.995,24.046c-0.014,1.303,0.253,9.894,0.619,21.784c0.301,9.685,0.668,21.601,1.014,33.738
		l-0.112,0.058c0.014,0.025,0.057,0.125,0.122,0.266c0.663,23.189,1.248,47.105,1.14,57.701c-0.056,5.56,1.991,10.855,5.619,14.508
		c5.028,5.065,10.642,9.486,15.807,12.434c5.276,3.015,11.561,4.296,17.63,5.535c1.282,0.26,2.544,0.522,3.775,0.789
		c7.29,1.604,14.73,2.879,22.118,3.804c10.153,1.259,20.556,1.892,31.135,1.892c10.131,0,20.429-0.575,30.813-1.74
		c7.75-0.857,15.566-2.044,23.236-3.528c1.216-0.235,2.445-0.46,3.689-0.69c6.276-1.15,12.769-2.341,18.593-4.923
		c5.563-2.462,10.5-6.748,14.857-10.532l0.304-0.267c2.014-1.746,4.521-3.92,6.357-6.449c1.581-2.174,2.389-4.965,2.286-7.85
		c-0.216-6,0.056-21.492,0.502-39.36c0.038-0.094,0.056-0.157,0.066-0.183l-0.062-0.02c0.179-6.988,0.381-14.336,0.588-21.618
		c0.065-0.144,0.103-0.244,0.117-0.271l-0.109-0.052c0.343-11.891,0.705-23.588,1-33.257c0.366-11.88,0.634-20.466,0.62-21.768
		c-0.018-2.199-0.863-12.631-1.995-24.046c9.994,8.869,24.104,35.268,29.531,49.996c1.939,5.279,4.164,13.516,6.516,22.244
		c4.712,17.476,9.59,35.561,14.195,38.053c2.454,1.333,6.13,2.023,10.294,2.023c7.008,0,15.396-1.96,21.645-6.152
		C441.586,313.029,441.544,304.311,441.539,303.946 M439.924,302.461c-1.676,3.534-3.248,4.787-4.023,5.211
		c-1.657-4.558-2.342-7.197-2.286-7.756c0.24-0.527,2.146-3.559,4.099-6.601C438.62,297.073,439.451,300.511,439.924,302.461
		 M433.357,274.213c0.029,0.151,0.056,0.302,0.08,0.449c0.056,0.303,0.108,0.597,0.16,0.879v0.006c0.022,0.13,0.047,0.26,0.07,0.385
		c0.047,0.251,0.094,0.481,0.141,0.701c0.018,0.115,0.042,0.23,0.065,0.334c0.014,0.073,0.033,0.151,0.052,0.241
		c0.009,0.057,0.022,0.115,0.037,0.172c0.01,0.052,0.024,0.106,0.033,0.161c0.099,0.44,0.222,0.995,0.367,1.637
		c0.017,0.083,0.037,0.163,0.055,0.246c0.099,0.424,0.207,0.889,0.32,1.381c0.09,0.376,0.184,0.767,0.277,1.175
		c0.052,0.208,0.099,0.423,0.151,0.642c0.116,0.486,0.234,0.993,0.356,1.516c0.042,0.173,0.084,0.35,0.127,0.527
		c0.056,0.235,0.113,0.476,0.168,0.716c0.118,0.507,0.24,1.024,0.366,1.547c-0.111,0.696-0.919,4.584-5.253,8.995l-4.168-14.09
		c0.09-0.078,0.193-0.157,0.283-0.235c3.506-3.026,5.319-5.901,6.233-7.84C433.306,273.914,433.334,274.066,433.357,274.213
		 M430.174,258.292c0.019,0.073,0.043,0.152,0.062,0.225v0.005l0.097,0.393c0.057,0.198,0.109,0.396,0.156,0.584
		c0.042,0.141,0.075,0.277,0.112,0.408c0.066,0.247,0.132,0.486,0.193,0.712c0.042,0.145,0.08,0.282,0.117,0.413
		c0.017,0.077,0.042,0.146,0.06,0.218c0.038,0.122,0.071,0.236,0.103,0.346c0,0.016,0.005,0.027,0.01,0.042
		c0.005,0.022,0.013,0.041,0.018,0.063c0.019,0.052,0.034,0.105,0.042,0.152c0.009,0.025,0.019,0.052,0.024,0.077
		c0.028,0.094,0.051,0.183,0.08,0.267c0.018,0.052,0.033,0.105,0.047,0.157c0.136,0.45,0.229,0.747,0.266,0.867
		c0.005,0.026,0.01,0.058,0.014,0.1c0.01,0.036,0.014,0.083,0.024,0.135c0.008,0.068,0.022,0.152,0.038,0.247v0.015
		c0.013,0.078,0.028,0.173,0.042,0.267c0.008,0.067,0.018,0.135,0.033,0.208c0.014,0.094,0.033,0.194,0.047,0.299
		c0,0.01,0.005,0.016,0.005,0.025c0.013,0.105,0.033,0.21,0.051,0.325c0.013,0.109,0.033,0.225,0.051,0.339
		c0.019,0.122,0.038,0.241,0.057,0.367c0.089,0.575,0.196,1.233,0.31,1.939c0.042,0.266,0.084,0.542,0.131,0.825
		c0.043,0.282,0.089,0.569,0.136,0.857c0.034,0.193,0.066,0.392,0.099,0.591c0.089,0.529,0.179,1.071,0.267,1.605
		c-0.333,1.133-1.742,4.939-6.468,9.058l-3.643-15.383c0.131-0.109,0.262-0.219,0.385-0.324c3.924-3.386,5.723-6.574,6.525-8.487
		C429.841,256.965,430.011,257.655,430.174,258.292 M403.273,171.946c-2.202,2.749-5.822,7.217-9.403,11.514
		c-0.023,0.042-0.056,0.078-0.084,0.116c-0.043,0.083-0.09,0.156-0.156,0.224c-0.211,0.261-0.45,0.492-0.685,0.722
		c0.005,0.01,0.009,0.02,0.019,0.026c-1.817,2.163-3.647,4.317-5.521,6.418c-1.789,2.002-3.652,3.945-5.77,5.514
		c-2.206,1.641-4.482,3.188-6.81,4.599c-1.01,0.611-2.028,1.197-3.066,1.74c-4.168,2.18-8.581,3.889-13.143,4.646
		c-3.122,0.513-6.324,0.565-9.431-0.073c-0.507-4.813-1.041-9.579-1.577-13.777c0.005,0.031,3.206-0.983,3.488-1.092
		c1.225-0.455,2.427-0.977,3.614-1.542c2.511-1.201,4.943-2.597,7.328-4.077c2.451-1.521,4.878-3.094,7.267-4.729
		c2.262-1.547,4.567-3.084,6.666-4.908c1.525-1.316,2.976-2.744,4.383-4.212c0.766-0.794,1.516-1.599,2.262-2.42
		c0.211-0.235,2.245-2.269,2.164-2.446c0.005,0.005,0.009,0.01,0.009,0.016c0.076-0.094,0.164-0.178,0.268-0.235
		c0.014-0.011,0.037-0.026,0.056-0.037c0.192-0.256,0.394-0.506,0.582-0.767c-0.005-0.011-0.009-0.022-0.014-0.026
		c4.328-5.07,8.032-9.993,9.436-11.88C398.208,161.545,401.08,167.452,403.273,171.946 M353.337,87.048
		c0.069-0.622,0.14-1.249,0.211-1.877c0.028-0.261,0.06-0.523,0.089-0.783c0.008-0.09,0.127-0.591,0.075-0.655
		c3.803,4.777,18.702,23.791,24.284,35.802c3.135,6.747,10.143,21.267,16.532,34.422c0.084,0.183-1.709,2.273-1.854,2.466
		c-1.141,1.495-2.301,2.979-3.47,4.443c-4.981,6.234-10.21,12.894-16.57,17.425c-4.643,3.313-9.429,6.528-14.355,9.324
		c-1.783,1.009-3.605,1.955-5.469,2.77c-0.422,0.188-5.323,1.981-5.337,1.871c-0.629-4.844-1.248-8.801-1.779-10.97
		c-0.239-0.962-0.253-2.002-0.282-2.994c-0.051-1.678-0.014-3.361,0.038-5.039c0.065-2.243,0.184-4.485,0.31-6.722
		c0.159-2.686,0.343-5.373,0.544-8.054c0.22-3.01,0.465-6.021,0.723-9.031c0.164-1.965,0.353-3.925,0.475-5.89
		c0.047-0.71,0.164-1.416,0.225-2.127c0.07-0.742,0.136-1.49,0.207-2.232c0.136-1.5,0.277-2.999,0.423-4.494
		c0.286-3.005,0.577-6.01,0.877-9.017c0.291-2.947,0.592-5.89,0.892-8.833c0.291-2.791,0.582-5.582,0.878-8.372
		c0.244-2.341,0.376-4.72,0.746-7.036c0.094-0.564,0.112-1.139,0.15-1.709c0.038-0.574,0.16-1.117,0.221-1.688
		c0.029-0.292,0.062-0.59,0.094-0.883c0.065-0.575,0.128-1.145,0.189-1.719c0.116-1.057,0.234-2.117,0.351-3.178
		C352.947,90.528,353.139,88.788,353.337,87.048 M151.136,98.932c8.276-9.203,19.518-20.451,33.404-26.493
		c3.657-1.583,7.417-3.088,11.05-4.541c5.174-2.071,10.525-4.208,15.679-6.638c1.319-0.617,2.629-1.249,3.897-1.866l1.995-0.789
		l-0.065-0.189c1.643-0.272,3.294-0.523,4.956-0.747c1.16-0.157,2.319-0.309,3.441-0.44c6.22-0.715,11.341-1.055,16.115-1.055h0.131
		c8.535,0.015,16.412,0.177,24.072,0.496c0.952,0.042,1.91,0.074,2.873,0.11c4.107,0.141,8.365,0.292,12.444,0.988l0.061,0.01
		c1.15,0.193,2.314,0.392,3.483,0.596l2.038,1.004c1.455,0.706,2.915,1.406,4.374,2.09c5.629,2.64,11.454,4.929,17.087,7.146
		c1.619,0.632,3.244,1.275,4.863,1.923c0.718,0.282,1.436,0.574,2.151,0.873c5.267,2.195,9.363,4.295,12.893,6.632
		c4.305,2.832,8.187,6.329,11.737,9.679c3.844,3.627,7.533,7.4,10.966,11.21c-2.897,26.635-7.934,75.931-6.268,82.719
		c0.151,0.611,0.306,1.364,0.47,2.238c0.025,0.13,0.047,0.266,0.07,0.402c0.052,0.271,0.099,0.558,0.151,0.851v0.005
		c0.051,0.293,0.099,0.597,0.149,0.91c0.025,0.161,0.052,0.318,0.077,0.481c0.046,0.298,0.093,0.606,0.14,0.919
		c0.005,0.026,0.009,0.052,0.014,0.078c0.052,0.346,0.103,0.694,0.155,1.056c0.014,0.094,0.029,0.188,0.037,0.282
		c0.052,0.34,0.104,0.69,0.151,1.046c0.069,0.511,0.145,1.04,0.215,1.578c0.065,0.482,0.128,0.973,0.193,1.474
		c0.065,0.517,0.136,1.04,0.202,1.579c0.051,0.429,0.103,0.863,0.159,1.301c0.009,0.073,0.018,0.151,0.028,0.225
		c0.128,1.066,0.258,2.163,0.39,3.281c0.023,0.193,0.043,0.388,0.065,0.581c0.042,0.366,0.085,0.737,0.127,1.108
		c0.01,0.099,0.025,0.199,0.034,0.298c0.051,0.469,0.107,0.946,0.159,1.421l-0.108-0.031c-0.018,0.073-1.731,7.4-7.294,10.134
		c-0.497,0.24-0.982,0.491-1.47,0.742c-0.624,0.324-1.276,0.658-1.914,0.962c-1.667,0.784-3.45,1.474-5.45,2.112
		c-2.69,0.857-5.662,1.599-9.332,2.336c-4.365,0.879-9.129,1.626-14.979,2.357c-6.661,0.826-13.768,1.511-22.373,2.154l-0.662,0.047
		c-9.839,0.737-20.011,1.489-30.005,1.679c-8.933,0.15-18.035-0.461-26.851-1.062c-1.267-0.084-2.534-0.173-3.796-0.251
		c-8.624-0.571-16.129-1.213-22.96-1.955c-6.177-0.674-11.266-1.364-16.002-2.179c-4.099-0.707-7.432-1.417-10.487-2.232
		c-2.45-0.654-4.563-1.338-6.445-2.096c-1.188-0.481-2.46-1.071-3.892-1.808l-0.432-0.23c-0.38-0.199-0.761-0.386-1.14-0.575
		c-5.577-2.739-7.37-9.136-7.389-9.198l-0.206,0.068c0.112-1.025,0.225-2.039,0.338-3.042c0.047-0.418,0.094-0.831,0.145-1.245
		c0.014-0.141,0.034-0.288,0.052-0.429c0.047-0.428,0.094-0.857,0.146-1.281c0.004-0.051,0.013-0.099,0.018-0.146
		c0.051-0.434,0.103-0.863,0.155-1.291c0.117-0.957,0.23-1.892,0.347-2.802c0.098-0.789,0.202-1.557,0.3-2.299
		c0.108-0.81,0.215-1.594,0.325-2.341c0.022-0.163,0.047-0.324,0.069-0.481c0.226-1.563,0.451-2.963,0.668-4.155
		c0.028-0.167,0.056-0.334,0.088-0.497c0.01-0.052,0.019-0.099,0.03-0.151c0.075-0.372,0.14-0.722,0.211-1.04
		c0.033-0.163,0.069-0.319,0.102-0.465c0.034-0.147,0.066-0.288,0.099-0.424C159.07,174.863,154.032,125.567,151.136,98.932
		 M338.911,74.452c0.187,0.099,0.376,0.199,0.563,0.298c0.521,0.272,1.037,0.549,1.544,0.826c0.066,0.036,0.137,0.073,0.202,0.109
		c0.207,0.109,0.413,0.225,0.616,0.34c0.069,0.036,0.136,0.073,0.201,0.109c0.544,0.299,1.071,0.597,1.587,0.894
		c0.192,0.11,0.385,0.219,0.572,0.328c0.193,0.11,0.381,0.215,0.564,0.325c0.676,0.391,1.324,0.773,1.935,1.139
		c0.23,0.136,0.46,0.277,0.681,0.407c0.065,0.037,0.132,0.08,0.196,0.12c0.216,0.132,0.433,0.261,0.639,0.388
		c0.033,0.02,0.07,0.041,0.103,0.063c0.15,0.089,0.296,0.183,0.441,0.272c0.446,0.272,0.869,0.533,1.254,0.779
		c0.207,0.131,0.408,0.251,0.597,0.372c0.028,0.016,0.056,0.036,0.08,0.052c0.159,0.105,0.314,0.199,0.454,0.292
		c0.146,0.089,0.283,0.177,0.413,0.261c0.094,0.063,0.183,0.115,0.267,0.173c0.333,0.219,0.601,0.392,0.794,0.517
		c-0.198,1.709-0.822,7.161-1.649,14.697c-3.263-3.58-6.741-7.124-10.359-10.537c-0.832-0.783-1.681-1.573-2.549-2.362
		c0.258-2.08,0.07-7.919-0.023-10.317C338.329,74.149,338.621,74.301,338.911,74.452 M319.923,67.177
		c0.409,0.115,0.813,0.225,1.217,0.34c0.085,0.02,0.168,0.047,0.249,0.068c0.727,0.203,1.44,0.402,2.13,0.596
		c0.689,0.193,1.366,0.386,2.013,0.569c0.409,0.115,0.818,0.246,1.235,0.382c0.211,0.068,0.418,0.135,0.629,0.209
		c0.211,0.067,0.424,0.141,0.634,0.219c0.535,0.188,1.075,0.392,1.619,0.606c0.193,0.074,0.389,0.152,0.592,0.23
		c0.577,0.236,1.159,0.476,1.747,0.733c0.022,0.009,0.05,0.02,0.075,0.031c0.038,0.016,0.08,0.036,0.117,0.052
		c0.159,0.068,0.314,0.135,0.474,0.209c0.197,0.089,0.395,0.173,0.592,0.266c0.423,0.194,0.849,0.388,1.272,0.585
		c0.033,0.016,0.065,0.032,0.098,0.048c0.423,0.199,0.845,0.402,1.263,0.606c0.3,0.141,0.601,0.288,0.901,0.439
		c0.127,3.089,0.244,7.71,0.137,9.926c-2.558-2.279-5.286-4.495-8.211-6.424c-2.582-1.704-5.454-3.287-8.839-4.87
		C320.116,70.904,320.022,68.655,319.923,67.177 M304.489,63.074c4.375,1.15,9.459,2.478,14.172,3.763
		c0.141,1.845,0.192,3.82,0.06,4.636c-0.99-0.444-2.027-0.893-3.112-1.343c-0.719-0.302-1.437-0.59-2.16-0.883
		c-1.623-0.643-3.247-1.286-4.872-1.923c-5.619-2.211-11.424-4.49-17.016-7.113c-0.661-0.314-1.319-0.633-1.976-0.947
		c1.197,0.225,2.531,0.497,3.873,0.8C294.139,60.356,297.19,61.166,304.489,63.074 M210.424,54.502
		c0.525-1.579,1.093-3.126,1.703-4.641c0.081-0.193,0.155-0.388,0.236-0.575c0-0.006,0.004-0.01,0.004-0.016
		c0.094-0.23,0.187-0.46,0.286-0.69c0.16-0.386,0.329-0.774,0.498-1.155c0.506-1.155,1.037-2.289,1.596-3.408
		c0.18-0.36,0.361-0.716,0.545-1.072c0.221-0.428,0.45-0.863,0.68-1.285c0.142-0.261,0.282-0.517,0.428-0.773
		c0.047-0.084,0.094-0.163,0.141-0.247c0.033-0.063,0.065-0.12,0.103-0.183c0.014-0.026,0.029-0.047,0.042-0.073
		c0.127-0.225,0.254-0.455,0.39-0.68c0.014-0.026,0.028-0.047,0.042-0.073c0.189-0.33,0.385-0.654,0.582-0.977
		c0.184-0.308,0.372-0.611,0.559-0.915c0.065-0.105,0.131-0.203,0.197-0.308c0.137-0.219,0.277-0.439,0.423-0.659
		c0.704-1.092,1.441-2.163,2.206-3.209c0.014-0.02,0.033-0.047,0.052-0.068c0.197-0.282,0.408-0.559,0.615-0.835
		c0.005-0.01,0.014-0.022,0.023-0.032c0.005-0.005,0.009-0.01,0.013-0.016c0.231-0.308,0.466-0.616,0.705-0.92
		c0.005-0.01,0.013-0.02,0.022-0.032c0.202-0.261,0.409-0.523,0.616-0.779c0.065-0.083,0.137-0.167,0.202-0.25
		c0.23-0.277,0.459-0.555,0.69-0.832c0.517-0.616,1.041-1.223,1.577-1.819c0.266-0.298,0.535-0.596,0.813-0.889
		c0.196-0.214,0.388-0.423,0.591-0.626c0.14-0.147,0.281-0.293,0.423-0.444c0.009-0.01,0.022-0.022,0.033-0.032
		c0.018-0.02,0.042-0.042,0.061-0.063c0.013-0.016,0.033-0.031,0.046-0.048c0.17-0.177,0.343-0.35,0.517-0.522
		c0.211-0.215,0.427-0.429,0.643-0.638c0.094-0.094,0.193-0.193,0.291-0.288c0.263-0.257,0.531-0.507,0.798-0.752
		c0.291-0.277,0.587-0.549,0.887-0.821c1.925-0.905,7.59-2.828,20.058-2.341v0.02c0.065-0.006,0.131-0.01,0.197-0.01
		c0.065,0,0.131,0.005,0.197,0.01v-0.02c12.467-0.486,18.134,1.437,20.057,2.341c0.301,0.272,0.596,0.543,0.892,0.821
		c0.278,0.261,0.558,0.527,0.831,0.794c0.272,0.266,0.545,0.538,0.818,0.805c0.276,0.272,0.549,0.549,0.821,0.831
		c0.273,0.277,0.54,0.559,0.802,0.847c0.267,0.282,0.531,0.569,0.789,0.857c0.263,0.288,0.522,0.58,0.775,0.873
		c0.511,0.585,1.014,1.175,1.506,1.777c0.164,0.199,0.325,0.403,0.489,0.607l0.005,0.005c0.042,0.052,0.08,0.1,0.121,0.152
		c0.029,0.042,0.06,0.078,0.094,0.119c0.615,0.78,1.221,1.574,1.803,2.383c0.188,0.251,0.366,0.507,0.544,0.764
		c0.061,0.083,0.117,0.167,0.179,0.25c0.193,0.277,0.385,0.555,0.573,0.832c0,0.005,0.005,0.009,0.01,0.015
		c0.225,0.335,0.45,0.669,0.666,1.009c0.226,0.34,0.442,0.68,0.656,1.024c0.216,0.346,0.433,0.69,0.639,1.04
		c0.215,0.346,0.424,0.696,0.625,1.05c0.206,0.35,0.412,0.706,0.609,1.066c0.203,0.356,0.399,0.716,0.592,1.077
		c0.197,0.36,0.389,0.726,0.578,1.092c0.365,0.7,0.723,1.411,1.065,2.132c0.193,0.402,0.386,0.81,0.569,1.217
		c0.178,0.376,0.347,0.758,0.515,1.145c0.338,0.763,0.663,1.537,0.977,2.321c0.136,0.334,0.267,0.668,0.399,1.008
		c0.023,0.058,0.042,0.115,0.066,0.173c0.135,0.356,0.272,0.712,0.403,1.066c0.164,0.444,0.324,0.889,0.479,1.338
		c0.14,0.398,0.277,0.8,0.412,1.203c0.137,0.413,0.273,0.831,0.404,1.249c-0.188-0.047-0.38-0.094-0.573-0.141
		c-0.822-0.209-1.605-0.402-1.854-0.449c-2.563-0.482-5.164-0.921-7.676-1.349l-0.226-0.036c-4.258-0.726-8.604-0.879-12.805-1.03
		l-0.136-0.005c-0.916-0.027-1.822-0.064-2.727-0.094c-7.732-0.33-15.642-0.491-24.186-0.502h-0.131c-0.46,0-0.92,0.006-1.389,0.011
		c-0.464,0.005-0.929,0.015-1.404,0.025c-0.634,0.016-1.272,0.037-1.915,0.068c-0.648,0.026-1.305,0.058-1.972,0.099
		c-0.333,0.022-0.671,0.042-1.009,0.064c-1.352,0.083-2.751,0.198-4.206,0.334c-1.456,0.136-2.967,0.292-4.549,0.481
		c-1.202,0.136-2.38,0.282-3.502,0.434c-3.468,0.469-6.918,1.045-10.251,1.698c-0.076,0.01-0.366,0.09-1.32,0.34
		c-0.022,0.006-0.055,0.016-0.08,0.02C210.146,55.344,210.283,54.921,210.424,54.502 M209.55,57.299
		c0.197-0.052,0.464-0.125,0.827-0.214c0.577-0.157,1.154-0.309,1.243-0.33c3.314-0.648,6.741-1.213,10.196-1.683
		c1.108-0.151,2.275-0.298,3.478-0.433c6.276-0.732,11.459-1.072,16.312-1.072h0.131c8.525,0.01,16.425,0.173,24.139,0.497
		c0.905,0.041,1.821,0.067,2.737,0.105h0.131c4.168,0.147,8.478,0.298,12.666,1.008l0.219,0.042
		c2.507,0.424,5.103,0.867,7.656,1.343c0.22,0.042,1.057,0.25,1.793,0.433c0.48,0.12,0.944,0.235,1.291,0.319
		c0.122,0.402,0.249,0.794,0.361,1.197c-1.253-0.277-2.483-0.513-3.558-0.716c-2.601-0.486-5.244-0.935-7.797-1.37l-0.061-0.005
		c-4.158-0.712-8.448-0.863-12.594-1.004c-0.959-0.036-1.915-0.068-2.869-0.11c-7.675-0.324-15.561-0.486-24.114-0.496h-0.131
		c-4.816,0-9.985,0.339-16.242,1.066c-1.127,0.13-2.301,0.276-3.469,0.433c-3.436,0.471-6.854,1.035-10.158,1.678
		c-0.813,0.163-1.676,0.33-2.553,0.523C209.301,58.104,209.429,57.707,209.55,57.299 M184.202,69.351
		c0-0.131,0.005-0.267,0.009-0.408c0.01-0.344,0.023-0.7,0.048-1.066c0.022-0.443,0.05-0.899,0.089-1.338h0.004
		c4.399-1.187,9.036-2.404,13.073-3.466c7.3-1.907,10.351-2.718,11.032-3.01c0.244-0.058,0.488-0.11,0.728-0.163h0.008
		c0.948-0.209,1.878-0.392,2.756-0.564c0.127-0.026,0.258-0.048,0.38-0.074c-0.511,0.245-1.023,0.497-1.534,0.736
		c-5.127,2.42-10.458,4.548-15.618,6.612c-3.595,1.438-7.318,2.928-10.947,4.5c-0.013-0.151-0.022-0.318-0.028-0.506
		c-0.005-0.158-0.009-0.33-0.009-0.508C184.192,69.864,184.192,69.612,184.202,69.351 M165.773,73.046
		c0.366-0.177,0.732-0.356,1.103-0.533c0.09-0.042,0.179-0.084,0.268-0.126c0.019-0.01,0.033-0.015,0.051-0.026
		c0.419-0.198,0.836-0.391,1.254-0.58c0.334-0.151,0.672-0.302,1.005-0.444c0.235-0.109,0.464-0.208,0.699-0.308
		c0.291-0.125,0.583-0.246,0.869-0.36c0.507-0.215,1.005-0.414,1.503-0.601c0.206-0.078,0.408-0.157,0.609-0.235
		c0.536-0.199,1.061-0.382,1.577-0.559c0.047-0.016,0.099-0.032,0.146-0.047c0.127-0.042,0.253-0.084,0.38-0.126
		c0.175-0.057,0.343-0.109,0.517-0.161c0.211-0.063,0.423-0.126,0.629-0.189c0.381-0.109,0.775-0.219,1.173-0.334
		c0.4-0.115,0.807-0.23,1.222-0.344c0.351-0.1,0.708-0.199,1.066-0.299c0.206-0.057,0.412-0.115,0.619-0.172
		c0.287-0.078,0.573-0.163,0.869-0.241c0.24-0.068,0.483-0.131,0.732-0.199c0.343-0.094,0.685-0.188,1.033-0.282
		c-0.099,1.312-0.211,3.486-0.038,4.751c-6.384,2.927-12.195,6.899-17.415,11.236C165.529,80.719,165.641,76.172,165.773,73.046
		 M150.095,81.999h0.004c0.085-0.058,0.175-0.115,0.267-0.173c0.094-0.063,0.188-0.12,0.292-0.188
		c0.149-0.1,0.313-0.199,0.483-0.309c0.456-0.288,0.972-0.61,1.545-0.966c0.089-0.052,0.184-0.11,0.273-0.167
		c0.093-0.058,0.192-0.116,0.286-0.178c0.329-0.198,0.672-0.413,1.033-0.627c0.164-0.099,0.329-0.203,0.497-0.303
		c0.507-0.302,1.037-0.621,1.596-0.946c0.184-0.109,0.372-0.219,0.564-0.33c0.944-0.548,1.948-1.123,2.995-1.704
		c0.211-0.115,0.423-0.23,0.634-0.35c0.23-0.125,0.464-0.25,0.699-0.381c0.197-0.105,0.394-0.209,0.591-0.314
		c0.522-0.283,1.047-0.559,1.582-0.837c0.357-0.188,0.718-0.371,1.08-0.554c-0.094,2.493-0.267,8.127-0.014,10.154
		c-5.126,4.391-9.656,9.079-13.557,13.38c-0.822-7.531-1.445-12.982-1.643-14.692C149.493,82.391,149.761,82.218,150.095,81.999
		 M123.919,119.535c5.582-12.01,20.481-31.025,24.283-35.802c-0.051,0.064,0.066,0.591,0.08,0.685
		c0.029,0.277,0.061,0.554,0.094,0.825c0.076,0.669,0.151,1.339,0.226,2.007c0.197,1.766,0.395,3.533,0.592,5.294
		c0.108,0.993,0.215,1.987,0.328,2.979c0.057,0.529,0.113,1.056,0.169,1.583c0.034,0.273,0.061,0.544,0.089,0.816
		c0.076,0.654,0.193,1.312,0.258,1.975c0.216,2.158,0.442,4.312,0.653,6.471c0.051,0.501,0.107,1.009,0.159,1.511
		c0.296,2.78,0.586,5.561,0.874,8.341c0.3,2.931,0.599,5.868,0.891,8.806c0.301,3.005,0.596,6.01,0.882,9.021
		c0.15,1.588,0.314,3.183,0.47,4.777c0.155,1.567,0.263,3.146,0.395,4.719c0.127,1.557,0.309,3.11,0.445,4.667
		c0.155,1.782,0.282,3.57,0.423,5.357c0.235,2.88,0.451,5.76,0.648,8.645c0.174,2.504,0.324,5.007,0.445,7.511
		c0.099,2.007,0.174,4.009,0.198,6.016c0.013,1.39,0.013,2.79-0.104,4.175c-0.022,0.261-0.047,0.518-0.084,0.78
		c-0.029,0.183-0.112,0.407-0.112,0.59c-0.532,2.17-1.15,6.126-1.779,10.97c-7.539-1.897-15.712-7.499-23.616-12.93
		c0,0-0.883-0.606-0.883-0.617c-0.376-0.198-0.751-0.423-1.061-0.737c-3.366-2.446-7.468-6.768-11.201-11.117
		c-0.333-0.288-0.601-0.642-0.887-0.998c-0.014-0.02-0.023-0.042-0.037-0.063c-4.545-5.363-8.375-10.49-9.37-11.838
		C113.775,140.802,120.784,126.282,123.919,119.535 M106.758,155.259c-0.056,0.125,1.187,1.583,1.3,1.73
		c0.644,0.851,1.286,1.694,1.94,2.529c1.713,2.2,3.459,4.375,5.247,6.502c3.615,4.301,7.329,8.665,11.67,12.073
		c0.615,0.486,1.244,0.946,1.887,1.384c4.671,3.178,9.248,6.492,14.129,9.272c3.601,2.054,7.37,3.883,11.337,4.866
		c-0.536,4.197-1.071,8.963-1.577,13.777c-4.675,0.957-9.502,0.366-14.055-1.024c-4.173-1.271-8.177-3.2-11.969-5.503
		c-2.705-1.641-5.244-3.518-7.77-5.473c-0.793-0.616-1.554-1.343-2.258-2.074c-0.746-0.774-1.469-1.573-2.187-2.378
		c-1.915-2.144-3.736-4.386-5.615-6.571c-0.605-0.7-1.197-1.416-1.794-2.112c-0.47-0.543-0.92-1.113-1.38-1.666
		c-0.882-1.072-1.765-2.148-2.642-3.225c-1.465-1.798-2.93-3.606-4.379-5.42C100.834,167.452,103.706,161.545,106.758,155.259
		 M69.317,269.728c0.034-0.198,0.065-0.391,0.095-0.59c0.013-0.078,0.028-0.158,0.042-0.235c0.052-0.335,0.103-0.658,0.154-0.977
		c0.104-0.654,0.202-1.271,0.291-1.834c0.019-0.094,0.034-0.189,0.043-0.277c0.033-0.183,0.061-0.36,0.085-0.523
		c0.004-0.016,0.009-0.031,0.009-0.047c0.057-0.355,0.108-0.675,0.151-0.951c0.013-0.109,0.033-0.214,0.046-0.308
		c0.014-0.1,0.029-0.189,0.042-0.267v-0.015c0.014-0.074,0.024-0.141,0.034-0.205c0.018-0.125,0.033-0.219,0.042-0.277
		c0.033-0.105,0.113-0.35,0.225-0.721c0.015-0.048,0.03-0.094,0.043-0.147c0.029-0.1,0.061-0.208,0.094-0.324
		c0-0.006,0.005-0.011,0.005-0.016c0.014-0.042,0.028-0.094,0.042-0.141c0.014-0.048,0.028-0.1,0.042-0.147
		c0.137-0.465,0.301-1.03,0.475-1.678c0.052-0.177,0.099-0.361,0.15-0.549c0.084-0.318,0.174-0.648,0.263-0.997
		c0.018-0.069,0.037-0.142,0.051-0.21c0.052-0.215,0.108-0.434,0.164-0.658c0.112-0.45,0.226-0.921,0.343-1.406
		c0.797,1.913,2.6,5.101,6.525,8.487c0.121,0.105,0.253,0.215,0.385,0.324l-3.643,15.383c-4.728-4.119-6.134-7.924-6.469-9.058
		C69.139,270.82,69.228,270.267,69.317,269.728 M66.079,285.459c0.009-0.036,0.018-0.073,0.028-0.109
		c0.07-0.303,0.141-0.601,0.211-0.889c0.15-0.643,0.3-1.265,0.437-1.861c0.047-0.203,0.094-0.402,0.141-0.596
		c0.07-0.303,0.141-0.601,0.211-0.889c0.047-0.219,0.099-0.428,0.146-0.638c0.022-0.105,0.05-0.209,0.069-0.314
		c0.023-0.099,0.047-0.205,0.07-0.303c0.014-0.047,0.024-0.089,0.033-0.131c0.014-0.058,0.029-0.119,0.042-0.177
		c0.034-0.167,0.077-0.328,0.109-0.481c0.004-0.016,0.004-0.026,0.009-0.042c0.008-0.031,0.013-0.068,0.023-0.099
		c0.033-0.147,0.065-0.293,0.094-0.428c0.022-0.1,0.047-0.189,0.065-0.277c0.029-0.141,0.061-0.272,0.085-0.398
		c0.023-0.103,0.047-0.198,0.065-0.291c0.014-0.052,0.023-0.106,0.033-0.158c0.014-0.052,0.024-0.105,0.033-0.151
		c0.025-0.094,0.043-0.183,0.057-0.261c0.022-0.131,0.052-0.267,0.08-0.408c0.019-0.089,0.038-0.183,0.056-0.282
		c0.018-0.12,0.043-0.247,0.07-0.376c0.023-0.125,0.047-0.256,0.07-0.388c0.103-0.542,0.211-1.133,0.32-1.756
		c0.915,1.939,2.728,4.815,6.233,7.84c0.089,0.078,0.188,0.157,0.282,0.235l-4.177,14.117c-4.31-4.391-5.126-8.321-5.244-9.021
		C65.849,286.432,65.966,285.94,66.079,285.459 M64.225,293.226c1.309,2.285,3.52,6.032,4.342,6.889
		c0.07,0.863-1.118,4.432-2.375,7.579c-0.774-0.398-2.483-1.626-4.202-5.233C62.469,300.497,63.308,297.015,64.225,293.226
		 M106.814,312.355c-0.573,1.563-1.141,3.001-1.705,4.27c-0.069,0.163-0.14,0.314-0.211,0.471c-0.069,0.151-0.135,0.303-0.206,0.455
		c-0.14,0.292-0.277,0.58-0.418,0.852c-0.065,0.135-0.136,0.272-0.206,0.407c-0.065,0.131-0.137,0.257-0.206,0.382
		c-0.005,0.006-0.01,0.016-0.01,0.022c-0.121,0.23-0.248,0.449-0.375,0.658c-0.01,0.009-0.014,0.026-0.025,0.036v0.006
		c-0.008,0.015-0.018,0.025-0.023,0.041c-0.009,0.016-0.022,0.036-0.032,0.052c-0.005,0.006-0.01,0.016-0.014,0.02
		c-0.065,0.116-0.137,0.226-0.207,0.33c-0.089,0.141-0.183,0.277-0.273,0.408c-0.08,0.115-0.159,0.225-0.239,0.33
		c-0.042,0.058-0.085,0.11-0.132,0.166c-0.085,0.106-0.174,0.21-0.258,0.305c-0.028,0.031-0.056,0.057-0.08,0.089
		c-0.061,0.068-0.121,0.13-0.183,0.182c-0.056,0.053-0.108,0.106-0.16,0.147c-0.075,0.064-0.146,0.122-0.215,0.173
		c-0.047,0.038-0.099,0.074-0.145,0.105c-0.061,0.042-0.122,0.08-0.184,0.11c-6.187,3.355-21.293,2.283-30.765-4.077
		c-7.624-5.117-8.74-11.849-8.909-13.777c0.206,0.36,0.412,0.7,0.614,1.009c0.066,0.103,0.137,0.202,0.202,0.297
		c0.136,0.199,0.267,0.382,0.399,0.555c0.065,0.089,0.132,0.173,0.197,0.256c0.066,0.078,0.127,0.157,0.193,0.235
		c0.107,0.13,0.215,0.251,0.318,0.366c0.104,0.115,0.207,0.225,0.31,0.324c0.103,0.103,0.201,0.198,0.3,0.292
		c0.253,0.236,0.492,0.428,0.719,0.591c0.112,0.078,0.215,0.152,0.32,0.219c0.051,0.038,0.102,0.068,0.149,0.094
		c0.099,0.063,0.189,0.109,0.274,0.151c0.3,0.157,0.525,0.241,0.662,0.277c0.028,0.01,0.056,0.016,0.075,0.022h0.019
		c0.017,0.005,0.037,0.01,0.042,0.01l0.464,0.083l0.197-0.469c3.549-8.713,2.685-9.413,2.314-9.707
		c-0.047-0.041-0.116-0.12-0.201-0.23c-0.043-0.058-0.09-0.12-0.141-0.188c-0.277-0.388-0.672-0.993-1.136-1.741
		c-0.056-0.094-0.118-0.189-0.179-0.288c-0.267-0.433-0.553-0.904-0.854-1.406c-0.009-0.01-0.019-0.025-0.028-0.036
		c-0.226-0.376-0.456-0.768-0.69-1.171c-0.117-0.193-0.231-0.392-0.348-0.591c-0.389-0.668-0.784-1.358-1.173-2.038
		c0.159-0.68,0.324-1.354,0.483-2.028c0.752,2.012,2.343,5.039,5.708,8.237c5.145,4.887,15.65,11.111,36.511,13.191
		C107.17,311.352,106.993,311.859,106.814,312.355 M107.809,309.511c-20.349-1.98-30.694-7.875-35.826-12.584l4.211-14.247
		c5.868,4.542,16.698,9.874,36.136,11.78C110.86,299.744,109.335,304.996,107.809,309.511 M114.87,285.146
		c-0.695,2.587-1.423,5.278-2.169,7.981c-19.753-1.902-30.478-7.333-36.126-11.822l3.648-15.413
		c5.957,4.574,16.936,9.909,36.618,11.749l0.056,0.038C116.235,280.082,115.56,282.596,114.87,285.146 M121.422,262.788
		c-1.282,3.476-2.671,8.201-4.141,13.489h-0.338c-19.748-1.845-30.54-7.213-36.271-11.702c-0.132-0.036-0.268-0.089-0.39-0.167
		c-0.201-0.12-0.365-0.314-0.511-0.506c-0.052-0.064-0.099-0.132-0.15-0.194c-0.019-0.026-0.042-0.047-0.061-0.074
		c-0.018-0.01-0.038-0.025-0.052-0.041c-0.005,0.005-0.005,0.016-0.005,0.016c-5.712-4.934-6.636-9.429-6.646-9.47l-0.146,0.031
		c0.812-3.721,1.615-8.268,2.019-13.05c0.967-11.419,19.277-59.367,19.837-60.821c0.155-0.318,1.46-2.989,3.449-7.076
		c0,0.036,0.287,0.36,0.315,0.392c0.121,0.157,0.249,0.308,0.371,0.465c0.296,0.366,0.587,0.726,0.882,1.092
		c0.738,0.915,1.48,1.829,2.22,2.745c0.887,1.092,1.774,2.179,2.666,3.261c0.479,0.585,0.959,1.165,1.441,1.745
		c0.474,0.571,0.93,1.166,1.422,1.715l0.061,0.063l0.137,0.151c0.117,0.131,0.234,0.261,0.351,0.398
		c0.418,0.497,0.818,1.014,1.239,1.511c0.46,0.543,0.92,1.087,1.381,1.625c0.694,0.81,1.393,1.62,2.097,2.42
		c0.634,0.716,1.269,1.426,1.911,2.128c0.535,0.584,1.08,1.165,1.633,1.73c0.306,0.308,0.596,0.674,0.939,0.935
		c0.371,0.276,0.746,0.564,1.108,0.862c0.399,0.33,0.784,0.685,1.188,1.009c0.407,0.328,0.826,0.638,1.244,0.951
		c0.182,0.141,0.365,0.276,0.548,0.407c0.46,0.346,0.925,0.68,1.394,1.004c0.531,0.372,1.071,0.738,1.61,1.092
		c0.596,0.392,1.197,0.774,1.803,1.145c0.652,0.402,1.315,0.79,1.98,1.166c0.709,0.397,1.418,0.784,2.141,1.149
		c0.751,0.388,1.511,0.758,2.282,1.108c0.794,0.36,1.597,0.701,2.404,1.02c0.83,0.328,1.666,0.632,2.511,0.915
		c0.86,0.282,1.722,0.533,2.601,0.758c0.882,0.23,1.769,0.423,2.665,0.58c0.901,0.161,1.812,0.288,2.723,0.366
		c0.854,0.077,1.709,0.115,2.563,0.115c1.558,0,3.126-0.141,4.694-0.44c-0.095,0.879-0.179,1.756-0.272,2.629
		C142.068,219.612,127.064,247.464,121.422,262.788 M152.301,224.117v-0.006c0.127-1.442,0.267-2.959,0.412-4.521
		c0.038-0.401,0.077-0.81,0.113-1.222c0.108-1.15,0.219-2.316,0.338-3.503c0.033-0.365,0.07-0.731,0.107-1.097l0.156-1.567
		c0.028-0.016,0.065-0.048,0.093-0.074l-0.075-0.125c0.103-1.05,0.215-2.107,0.324-3.162c0.094-0.92,0.193-1.84,0.292-2.755
		c1.018,2.315,3.22,6.042,7.336,8.06c0.371,0.183,0.747,0.376,1.113,0.569l0.437,0.225c1.464,0.758,2.774,1.364,3.995,1.855
		c1.928,0.774,4.079,1.48,6.576,2.144c3.089,0.825,6.455,1.547,10.595,2.252c4.759,0.821,9.861,1.516,16.067,2.19
		c6.845,0.747,14.37,1.385,23.007,1.955c1.268,0.089,2.531,0.173,3.798,0.256c7.868,0.539,15.97,1.088,23.988,1.088
		c0.985,0,1.976-0.01,2.957-0.026c10.027-0.183,20.213-0.941,30.071-1.679l0.656-0.047c8.624-0.642,15.754-1.328,22.434-2.163
		c5.877-0.727,10.665-1.48,15.058-2.363c3.722-0.747,6.722-1.499,9.458-2.372c2.047-0.654,3.882-1.359,5.591-2.164
		c0.661-0.314,1.324-0.654,1.953-0.988c0.484-0.246,0.963-0.497,1.451-0.732c4.009-1.965,6.168-5.953,7.201-8.565
		c0.103,0.956,0.202,1.913,0.305,2.873v0.006c0.122,1.187,0.244,2.368,0.361,3.544l-0.076,0.125
		c0.029,0.026,0.065,0.058,0.095,0.078c0.069,0.722,0.14,1.438,0.211,2.148c0.069,0.716,0.14,1.422,0.206,2.127
		c0.038,0.372,0.069,0.748,0.107,1.114c0.057,0.585,0.113,1.166,0.164,1.741c0.042,0.423,0.081,0.846,0.118,1.264
		c0.022,0.241,0.047,0.481,0.065,0.722c0.089,0.96,0.174,1.902,0.253,2.811c0.052,0.586,0.099,1.156,0.146,1.715l-0.164-0.089
		c-0.039,0.089-3.868,8.947-9.501,11.707c-0.502,0.241-0.991,0.496-1.483,0.747c-0.653,0.346-1.334,0.69-2.005,1.009
		c-1.731,0.805-3.596,1.521-5.713,2.174c-2.835,0.883-5.976,1.651-9.881,2.41c-4.638,0.899-9.713,1.662-15.961,2.404
		c-7.102,0.835-14.702,1.531-23.921,2.169l-1.436,0.099c-9.857,0.685-20.054,1.396-30.071,1.396h-0.329
		c-8.204-0.016-16.603-0.627-24.72-1.222c-1.563-0.116-3.112-0.232-4.666-0.34c-8.285-0.586-15.199-1.214-21.752-1.966
		c-5.844-0.669-10.657-1.353-15.139-2.158c-3.867-0.7-7.017-1.396-9.909-2.2c-2.309-0.636-4.309-1.312-6.097-2.053
		c-1.104-0.456-2.253-0.999-3.727-1.762l-0.278-0.147c-0.365-0.189-0.732-0.382-1.103-0.559c-5.651-2.771-9.562-10.699-9.6-10.773
		l-0.239,0.136C152.141,225.962,152.221,225.053,152.301,224.117 M348.271,318.502c-0.014,0.715-0.034,1.426-0.047,2.132
		c-0.005,0.051-0.005,0.109-0.005,0.167c-0.014,0.486-0.023,0.967-0.033,1.447c-0.014,0.534-0.023,1.067-0.037,1.596
		c-0.01,0.481-0.019,0.96-0.029,1.436c-0.01,0.367-0.018,0.733-0.023,1.093c-0.01,0.36-0.019,0.721-0.025,1.077
		c-0.013,0.496-0.022,0.988-0.033,1.473c-0.004,0.397-0.014,0.789-0.022,1.182c0,0.172-0.005,0.343-0.01,0.517
		c-0.004,0.344-0.014,0.689-0.018,1.029c-0.009,0.513-0.018,1.02-0.029,1.516c-0.009,0.501-0.014,0.998-0.022,1.484
		c-0.005,0.33-0.01,0.654-0.019,0.972c-0.009,0.694-0.019,1.38-0.028,2.049c-0.005,0.334-0.01,0.664-0.015,0.992
		c-0.022,1.641-0.042,3.193-0.056,4.652c-0.005,0.632-0.008,1.249-0.013,1.84v0.019c0,0.602-0.005,1.182-0.005,1.746
		c0,0-0.005,0,0,0.006c-0.005,1.181-0.005,2.273,0,3.267c0.005,0.607,0.01,1.176,0.018,1.704c0.005,0.178,0.005,0.35,0.01,0.517
		c0.004,0.147,0.009,0.283,0.009,0.419c0,0.025,0,0.047,0.005,0.073c0,0.141,0.004,0.276,0.009,0.413
		c0.004,0.215,0.008,0.418,0.018,0.616c0.089,2.556-0.624,5.014-2.014,6.937c-1.75,2.404-4.192,4.525-6.159,6.229l-0.305,0.268
		c-4.295,3.72-9.153,7.948-14.551,10.336c-5.703,2.526-12.13,3.706-18.345,4.845c-1.243,0.225-2.479,0.456-3.698,0.691
		c-7.638,1.473-15.426,2.66-23.147,3.517c-21.137,2.362-41.89,2.311-61.695-0.156c-7.351-0.915-14.758-2.19-22.01-3.78
		c-1.234-0.272-2.502-0.532-3.792-0.799c-5.985-1.217-12.178-2.482-17.289-5.405c-5.075-2.895-10.594-7.239-15.547-12.229
		c-3.366-3.393-5.261-8.306-5.209-13.48c0.013-1.39,0.013-3.01,0.008-4.824c0-0.11,0-0.219-0.005-0.33
		c0-0.543-0.003-1.103-0.008-1.682v-0.09c-0.005-0.244-0.005-0.491-0.005-0.737c-0.005-0.496-0.009-1.004-0.019-1.521
		c-0.009-0.727-0.017-1.48-0.028-2.247c-0.005-0.376-0.009-0.758-0.014-1.145c-0.01-0.508-0.013-1.025-0.023-1.548
		c-0.014-0.867-0.029-1.755-0.047-2.66c-0.004-0.303-0.009-0.607-0.014-0.915c-0.009-0.527-0.018-1.066-0.028-1.609
		c-0.005-0.083-0.005-0.168-0.005-0.251c-0.009-0.302-0.014-0.606-0.018-0.914c-0.009-0.303-0.014-0.617-0.018-0.925
		c-0.01-0.543-0.024-1.088-0.033-1.647c-0.005-0.126-0.005-0.251-0.01-0.376c-0.014-0.652-0.029-1.322-0.042-1.991
		c-0.01-0.334-0.014-0.674-0.025-1.009c-0.004-0.34-0.013-0.68-0.022-1.023c-0.005-0.34-0.014-0.685-0.024-1.031
		c-0.004-0.344-0.013-0.69-0.022-1.034c-0.01-0.35-0.014-0.696-0.023-1.046c-0.024-1.05-0.047-2.111-0.076-3.182
		c1.394,2.665,3.949,6.507,7.792,8.393c0.367,0.18,0.723,0.367,1.08,0.55l0.282,0.147c1.503,0.777,2.68,1.337,3.816,1.803
		c1.835,0.764,3.873,1.448,6.229,2.1c2.93,0.81,6.112,1.516,10.017,2.221c4.507,0.81,9.342,1.501,15.204,2.174
		c6.571,0.754,13.501,1.38,21.804,1.971c1.55,0.11,3.102,0.219,4.662,0.335c8.139,0.6,16.556,1.212,24.803,1.228h0.329
		c10.059,0,20.274-0.71,30.15-1.401l1.436-0.094c9.233-0.642,16.857-1.337,23.973-2.183c6.276-0.742,11.373-1.506,16.04-2.41
		c3.952-0.768,7.13-1.537,10.007-2.436c2.168-0.674,4.083-1.405,5.859-2.237c0.699-0.324,1.384-0.68,2.051-1.024
		c0.484-0.251,0.968-0.502,1.46-0.743c0.197-0.093,0.39-0.197,0.577-0.302c0.039-0.02,0.077-0.041,0.113-0.063
		c0.15-0.089,0.296-0.177,0.441-0.266c0.009-0.006,0.019-0.011,0.029-0.016c0.065-0.042,0.132-0.084,0.192-0.125
		c0.137-0.089,0.273-0.183,0.404-0.277c0.076-0.052,0.155-0.11,0.23-0.168c0.137-0.099,0.273-0.203,0.404-0.307
		c0.132-0.106,0.258-0.21,0.385-0.321c0.038-0.025,0.075-0.061,0.112-0.093c0.066-0.057,0.132-0.115,0.193-0.173
		c0.065-0.052,0.127-0.115,0.192-0.172c0.338-0.315,0.663-0.639,0.972-0.973c0.347-0.376,0.676-0.764,0.986-1.155
		c0.141-0.178,0.278-0.356,0.407-0.533c0.109-0.141,0.212-0.288,0.31-0.428c0.085-0.116,0.164-0.23,0.244-0.346
		c0.081-0.119,0.165-0.24,0.245-0.365c0.055-0.084,0.107-0.163,0.159-0.247c0.009-0.016,0.019-0.031,0.028-0.047
		c0.104-0.163,0.202-0.324,0.3-0.481c0.019-0.032,0.038-0.058,0.057-0.089c0.132-0.225,0.258-0.446,0.376-0.659
		c0.061-0.11,0.121-0.215,0.179-0.318c0.056-0.105,0.112-0.205,0.163-0.303C348.29,317.728,348.281,318.115,348.271,318.502
		 M348.792,298.818v0.006c-0.028,0.946-0.056,1.897-0.08,2.844c-0.009,0.199-0.013,0.392-0.018,0.591
		c-0.094,3.49-0.188,6.95-0.273,10.336c-0.014,0.513-0.023,1.021-0.038,1.526c-0.572,1.433-3.309,7.725-8.289,10.166
		c-0.502,0.246-0.991,0.497-1.483,0.748c-0.653,0.344-1.334,0.69-2.005,1.008c-1.731,0.805-3.596,1.521-5.713,2.179
		c-2.835,0.88-5.976,1.648-9.881,2.405c-1.16,0.225-2.347,0.439-3.573,0.654c-0.61,0.105-1.234,0.203-1.869,0.308
		c-0.313,0.047-0.633,0.099-0.957,0.151c-0.273,0.042-0.549,0.084-0.827,0.125c-0.83,0.126-1.68,0.247-2.549,0.373
		c-0.39,0.051-0.778,0.103-1.178,0.161c-0.53,0.074-1.065,0.147-1.614,0.215c-0.362,0.047-0.733,0.093-1.104,0.141
		c-0.746,0.089-1.512,0.183-2.291,0.276c-7.102,0.837-14.702,1.531-23.921,2.17l-1.436,0.099
		c-9.857,0.684-20.054,1.395-30.071,1.395h-0.329c-8.204-0.015-16.603-0.626-24.72-1.223c-1.563-0.114-3.112-0.23-4.666-0.34
		c-8.285-0.584-15.199-1.212-21.752-1.964c-5.844-0.669-10.657-1.354-15.139-2.158c-3.867-0.701-7.017-1.396-9.909-2.2
		c-2.309-0.639-4.309-1.312-6.097-2.055c-1.104-0.453-2.253-0.998-3.727-1.759l-0.278-0.147c-0.365-0.189-0.732-0.376-1.103-0.56
		c-5.342-2.618-8.101-9.653-8.379-10.39c-0.018-0.743-0.038-1.484-0.056-2.232c-0.004-0.167-0.009-0.34-0.014-0.506
		c-0.028-1.051-0.056-2.113-0.085-3.178c-0.023-1.035-0.051-2.071-0.08-3.115c-0.061-2.17-0.117-4.359-0.179-6.549
		c-0.023-0.883-0.051-1.772-0.075-2.655c1.586,2.723,4.455,6.768,8.36,8.681c0.371,0.183,0.747,0.376,1.113,0.571l0.437,0.23
		c1.464,0.752,2.774,1.358,3.995,1.85c1.928,0.777,4.079,1.478,6.576,2.147c3.089,0.821,6.455,1.542,10.595,2.253
		c0.295,0.053,0.596,0.1,0.896,0.151c0.901,0.152,1.816,0.298,2.75,0.44c0.621,0.093,1.254,0.188,1.893,0.282
		c0.318,0.047,0.643,0.094,0.967,0.135c0.409,0.058,0.817,0.116,1.234,0.174c0.249,0.031,0.497,0.067,0.751,0.099
		c1.348,0.177,2.742,0.35,4.197,0.523c1.093,0.131,2.216,0.26,3.379,0.385c6.845,0.743,14.37,1.38,23.007,1.95
		c1.268,0.089,2.531,0.178,3.798,0.257c7.868,0.538,15.97,1.087,23.988,1.087c0.985,0,1.976-0.011,2.957-0.027
		c10.027-0.182,20.213-0.94,30.071-1.676l0.656-0.048c8.624-0.643,15.754-1.328,22.434-2.163c5.877-0.726,10.665-1.479,15.058-2.363
		c3.722-0.748,6.722-1.5,9.458-2.372c2.047-0.649,3.882-1.359,5.591-2.164c0.661-0.314,1.324-0.654,1.953-0.983
		c0.484-0.251,0.963-0.501,1.451-0.737c3.887-1.907,6.717-6.109,8.285-8.985C348.853,296.514,348.821,297.664,348.792,298.818
		 M349.947,228.01c0.395,4.71,0.639,8.19,0.648,9.356c0.005,1.274-0.258,9.846-0.62,21.71c-0.3,9.649-0.661,21.329-1.005,33.203
		c-0.77,1.741-3.985,8.384-8.876,10.787c-0.497,0.24-0.982,0.491-1.47,0.742c-0.624,0.324-1.276,0.658-1.914,0.962
		c-1.667,0.784-3.45,1.473-5.45,2.112c-2.69,0.857-5.662,1.599-9.332,2.337c-4.365,0.877-9.129,1.624-14.979,2.356
		c-6.661,0.825-13.768,1.511-22.373,2.153l-0.662,0.048c-9.839,0.738-20.011,1.495-30.005,1.678
		c-8.933,0.152-18.035-0.459-26.851-1.056c-1.267-0.089-2.534-0.177-3.796-0.256c-8.624-0.569-16.129-1.213-22.96-1.955
		c-6.177-0.669-11.266-1.364-16.002-2.179c-4.099-0.706-7.432-1.416-10.487-2.232c-2.45-0.654-4.563-1.338-6.445-2.096
		c-1.188-0.476-2.46-1.071-3.892-1.808l-0.432-0.23c-0.38-0.194-0.761-0.386-1.14-0.575c-4.872-2.394-8.135-8.619-8.956-10.312
		c-0.343-12.114-0.709-24.005-1.01-33.668c-0.023-0.737-0.043-1.458-0.066-2.169c-0.009-0.356-0.022-0.706-0.033-1.051
		c-0.009-0.26-0.014-0.522-0.023-0.777c-0.005-0.257-0.013-0.514-0.023-0.764c-0.014-0.507-0.028-1.004-0.042-1.495
		c-0.009-0.241-0.019-0.485-0.025-0.722c-0.022-0.721-0.042-1.421-0.065-2.095c-0.004-0.293-0.014-0.581-0.022-0.863
		c-0.01-0.303-0.019-0.601-0.029-0.893c-0.005-0.283-0.013-0.565-0.023-0.838c-0.009-0.302-0.019-0.606-0.029-0.899
		c-0.004-0.177-0.009-0.355-0.013-0.526c-0.01-0.315-0.019-0.617-0.029-0.915c-0.009-0.251-0.014-0.492-0.018-0.727
		c-0.005-0.042-0.005-0.078-0.005-0.119c-0.005-0.163-0.01-0.324-0.014-0.481c0-0.032,0-0.058-0.005-0.089
		c-0.008-0.319-0.018-0.627-0.028-0.926c0-0.125-0.005-0.25-0.01-0.371c0-0.147-0.004-0.288-0.008-0.428
		c0-0.058-0.005-0.109-0.005-0.167c-0.004-0.099-0.009-0.193-0.009-0.288c-0.005-0.094-0.01-0.188-0.01-0.276
		c-0.004-0.183-0.009-0.361-0.014-0.529c-0.003-0.173-0.008-0.34-0.013-0.497c-0.004-0.105-0.004-0.209-0.004-0.308
		c-0.01-0.241-0.015-0.471-0.019-0.68c-0.009-0.299-0.013-0.565-0.018-0.794c0-0.1-0.005-0.193-0.005-0.282
		c-0.005-0.351-0.009-0.601-0.009-0.752c0.009-1.109,0.23-4.312,0.591-8.677c1.418,2.488,4.844,7.778,9.487,10.057
		c0.367,0.177,0.723,0.365,1.08,0.548l0.282,0.147c1.503,0.78,2.68,1.333,3.816,1.803c1.835,0.764,3.873,1.448,6.229,2.102
		c2.93,0.809,6.112,1.516,10.017,2.222c4.507,0.809,9.342,1.499,15.204,2.173c6.571,0.752,13.501,1.38,21.804,1.971
		c1.55,0.109,3.102,0.219,4.662,0.334c8.139,0.6,16.556,1.212,24.803,1.228h0.329c10.059,0,20.274-0.71,30.15-1.4l1.436-0.093
		c9.233-0.643,16.857-1.339,23.973-2.185c6.276-0.742,11.373-1.506,16.04-2.41c3.952-0.768,7.13-1.538,10.007-2.436
		c2.168-0.675,4.083-1.412,5.859-2.238c0.699-0.324,1.384-0.679,2.051-1.024c0.484-0.251,0.968-0.501,1.46-0.741
		C345.164,236.508,348.506,230.838,349.947,228.01 M384.633,276.277c-1.47-5.289-2.859-10.013-4.141-13.489
		c-5.642-15.324-20.644-43.176-30.851-51.356c-0.093-0.873-0.178-1.75-0.272-2.629c1.568,0.299,3.135,0.44,4.695,0.44
		c2.459,0,4.914-0.33,7.321-0.905c2.33-0.554,4.615-1.338,6.841-2.279c2.055-0.873,4.065-1.881,6.022-2.999
		c1.652-0.941,3.267-1.965,4.844-3.057c1.212-0.841,2.4-1.736,3.568-2.639c0.493-0.376,0.916-0.857,1.413-1.233
		c0.353-0.273,0.69-0.497,1.019-0.805c0.695-0.664,1.362-1.371,2.019-2.081c1.844-1.99,3.623-4.055,5.384-6.135
		c0.896-1.056,1.793-2.122,2.676-3.188c0.365-0.439,0.732-0.879,1.093-1.317c0.71-0.851,1.408-1.709,2.113-2.566
		c1.21-1.479,2.417-2.957,3.619-4.448c0.634-0.789,1.267-1.578,1.901-2.368c1.991,4.087,3.295,6.758,3.45,7.076
		c0.554,1.442,18.87,49.401,19.837,60.821c0.404,4.783,1.207,9.329,2.019,13.045l-0.146-0.025c0,0-0.08,0.308-0.085,0.324
		c-0.09,0.298-0.192,0.596-0.304,0.883c-0.184,0.459-0.39,0.909-0.616,1.348c-0.305,0.596-0.643,1.171-1.005,1.72
		c-0.46,0.705-0.963,1.374-1.492,2.007c-0.648,0.779-1.338,1.515-2.061,2.205c-0.15,0.141-0.305,0.277-0.455,0.414
		c-0.154,0.141-0.291,0.307-0.437,0.459c-0.352,0.366-0.761,0.658-1.163,0.951c-0.42,0.303-0.832,0.617-1.249,0.92
		c-0.188,0.136-0.38,0.267-0.569,0.402c-0.365,0.251-0.741,0.501-1.113,0.742c-0.403,0.257-0.807,0.508-1.215,0.748
		c-0.432,0.256-0.869,0.507-1.31,0.748c-0.47,0.26-0.939,0.506-1.413,0.747c-0.507,0.257-1.014,0.501-1.526,0.737
		c-0.539,0.251-1.084,0.492-1.629,0.726c-0.582,0.247-1.163,0.482-1.751,0.711c-0.619,0.24-1.239,0.471-1.863,0.69
		c-0.661,0.231-1.324,0.455-1.986,0.664c-0.704,0.225-1.409,0.433-2.113,0.638c-0.746,0.215-1.491,0.413-2.244,0.606
		c-0.788,0.205-1.577,0.392-2.37,0.569c-0.835,0.189-1.671,0.366-2.511,0.529c-0.882,0.177-1.765,0.34-2.647,0.486
		c-0.93,0.156-1.859,0.302-2.793,0.439c-0.977,0.141-1.958,0.266-2.939,0.386c-1.028,0.12-2.056,0.23-3.088,0.325
		c-0.047,0.003-0.094,0.009-0.141,0.015H384.633z M387.045,285.146c-0.69-2.549-1.366-5.064-2.027-7.467l0.055-0.038
		c19.684-1.84,30.664-7.175,36.62-11.749l3.647,15.413c-5.647,4.488-16.374,9.92-36.127,11.822
		C388.468,290.424,387.74,287.733,387.045,285.146 M389.584,294.459c19.435-1.906,30.269-7.238,36.137-11.78l4.206,14.217
		c-5.591,5.136-16.106,10.698-35.821,12.615C392.58,304.996,391.054,299.744,389.584,294.459 M431.372,318.292
		c-9.472,6.36-24.579,7.432-30.766,4.077c-0.055-0.031-0.116-0.068-0.174-0.105c-0.055-0.036-0.107-0.073-0.164-0.115
		c-0.028-0.022-0.052-0.043-0.08-0.063c-0.047-0.036-0.089-0.074-0.136-0.116c-0.428-0.376-0.864-0.914-1.305-1.594
		c-0.014-0.022-0.028-0.042-0.043-0.069c-0.069-0.114-0.146-0.23-0.215-0.355c-0.057-0.093-0.117-0.193-0.175-0.292
		c-1.215-2.086-2.479-5.175-3.755-8.828c20.861-2.08,31.366-8.304,36.511-13.191c3.366-3.198,4.957-6.225,5.708-8.243
		c0.175,0.733,0.348,1.474,0.526,2.206c-0.051,0.078-0.103,0.161-0.164,0.25c-0.112,0.174-0.239,0.372-0.371,0.581
		c-0.074,0.116-0.15,0.235-0.231,0.355c-0.032,0.052-0.065,0.1-0.093,0.152c-0.118,0.177-0.235,0.361-0.352,0.549
		c-0.061,0.094-0.127,0.193-0.188,0.292c-0.122,0.193-0.249,0.392-0.381,0.597c-0.065,0.099-0.127,0.203-0.192,0.302
		c-0.066,0.105-0.132,0.203-0.197,0.309c-0.112,0.172-0.226,0.35-0.334,0.522c-0.008,0.017-0.018,0.032-0.028,0.048
		c-0.179,0.276-0.352,0.559-0.527,0.831l-0.253,0.408c-0.08,0.131-0.159,0.26-0.239,0.386c-0.075,0.125-0.151,0.246-0.226,0.366
		c0,0,0,0.006-0.005,0.01c-0.121,0.199-0.239,0.388-0.342,0.565c-0.094,0.156-0.178,0.297-0.258,0.434
		c-0.038,0.067-0.076,0.13-0.108,0.193c-0.037,0.057-0.069,0.114-0.099,0.172c-0.121,0.214-0.206,0.376-0.243,0.471
		c-0.128,0.34-0.475,1.233,2.37,9.011c0.103,0.288,0.305,0.501,0.553,0.622c0.127,0.057,0.258,0.089,0.39,0.089
		c0.137,0,0.267-0.032,0.39-0.089c0.052-0.026,0.107-0.052,0.168-0.084c0.043-0.02,0.09-0.048,0.137-0.073
		c0.028-0.016,0.055-0.031,0.085-0.047c0.051-0.032,0.107-0.069,0.163-0.106c0.142-0.089,0.291-0.188,0.45-0.313
		c0.151-0.116,0.31-0.251,0.48-0.408c0.004-0.006,0.014-0.01,0.019-0.016c0.069-0.068,0.144-0.136,0.215-0.209
		c0.056-0.052,0.107-0.105,0.164-0.163c0.09-0.094,0.179-0.192,0.272-0.292c0.235-0.261,0.475-0.555,0.719-0.889
		c0.051-0.063,0.098-0.131,0.15-0.203c0.047-0.068,0.099-0.141,0.15-0.215c0.009-0.01,0.019-0.02,0.029-0.036
		c0.005-0.005,0.005-0.01,0.005-0.01c0.291-0.424,0.591-0.905,0.891-1.447C440.108,306.476,438.976,313.191,431.372,318.292"
        />
      </g>
    </svg>
  );
}
